(function() {
  'use strict';

  angular
    .module('oresell', ['ngAnimate', 'ngSanitize', 'ngMessages', 'ui.router', 'ui.bootstrap', 'toastr', 'angular-loading-bar', 'angular-jwt', 'angular-storage', 'ui.select', 'ng-locale-number', 'vcRecaptcha', 'Api.DuplicateRequestsFilter.Decorator', 'nvd3']);

})();

(function () {
  'use strict';

  angular
    .module('oresell')
    .factory('user', user);

  function user($q, $log, store, APIHandling) {

    // var this = this;

    this.getData = function () {
      return store.get('oresell_user');
    };

    this.register = function (data) {
      return APIHandling.post('register', data);
    };

    this.checkBalance = function () {
      return APIHandling.get('get-balance');
    };

    return this;
  }

})();

(function() {
  'use strict';

  angular.module('oresell').factory('transaction', transaction);

  function transaction(APIHandling, $http, $q, $log) {
    // var instance = this;

    this.list = function(filter) {
      var q = $q.defer();

      angular.element('.loading-animation').show();

      APIHandling.get('transaction', filter)
        .then(
          function(response) {
            q.resolve(response);
          },
          function(error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function() {
          angular.element('.loading-animation').hide();
        });

      return q.promise;
    };

    this.get = function(id) {
      var q = $q.defer();

      angular.element('.loading-animation').show();

      APIHandling.get('transaction/' + id)
        .then(
          function(response) {
            q.resolve(response);
          },
          function(error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function() {
          angular.element('.loading-animation').hide();
        });

      return q.promise;
    };

    this.save = function(data) {
      var q = $q.defer();

      angular.element('.loading-animation').show();

      APIHandling.post('transaction', data)
        .then(
          function(response) {
            q.resolve(response);
          },
          function(error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function() {
          angular.element('.loading-animation').hide();
        });

      return q.promise;
    };

    this.cancel = function(id) {
      var q = $q.defer();

      angular.element('.loading-animation').show();

      APIHandling.post('transaction/cancel', { id: id })
        .then(
          function(response) {
            q.resolve(response);
          },
          function(error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function() {
          angular.element('.loading-animation').hide();
        });

      return q.promise;
    };

    this.getBestSeller = function(filter) {
      var q = $q.defer();

      angular.element('.loading-animation').show();

      APIHandling.get('transaction/bestseller', filter)
        .then(
          function(response) {
            q.resolve(response);
          },
          function(error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function() {
          angular.element('.loading-animation').hide();
        });

      return q.promise;
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("oresell").factory("topup", topup);

  function topup(APIHandling, $http, $q, $log) {
    // var instance = this;

    this.list = function (filter) {
      var q = $q.defer();
      angular.element(".loading-animation").show();

      APIHandling.get("topup", filter)
        .then(
          function (response) {
            q.resolve(response);
          },
          function (error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function () {
          angular.element(".loading-animation").hide();
        });

      return q.promise;
    };

    this.save = function (value, bank) {
      var q = $q.defer();
      var apiCall;

      apiCall = APIHandling.post("topup", { deposit: value, bank: bank });

      angular.element(".loading-animation").show();

      apiCall
        .then(
          function (response) {
            q.resolve(response);
          },
          function (error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function () {
          angular.element(".loading-animation").hide();
        });

      return q.promise;
    };

    this.confirm = function (data) {
      var q = $q.defer();
      var apiCall;

      apiCall = APIHandling.post("topup/confirm-with-queue", {
        ticketId: data.id,
        transfer: data.total_transfer * 1,
      });

      angular.element(".loading-animation").show();

      apiCall
        .then(
          function (response) {
            q.resolve(response);
          },
          function (error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function () {
          angular.element(".loading-animation").hide();
        });

      return q.promise;
    };

    return this;
  }
})();

(function () {
  'use strict';

  angular
    .module('oresell')
    .factory('settings', settings);

  function settings(APIHandling, $q) {
    var instance = this;

    instance.getBase = function () {

      var defered = $q.defer();

      APIHandling.get('settings').then(function (response) {
        defered.resolve(response);
      }, function () {
        defered.reject();
      });

      return defered.promise;
    };

    return instance;
  }

})();

(function() {
  'use strict';

  angular.module('oresell').factory('product', product);

  function product($q, $log, APIHandling) {
    // var instance = this;

    this.list = function(filter) {
      var q = $q.defer();

      angular.element('.loading-animation').show();

      APIHandling.get('product', filter)
        .then(
          function(response) {
            q.resolve(response);
          },
          function(error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function() {
          angular.element('.loading-animation').hide();
        });

      return q.promise;
    };

    return this;
  }
})();

(function () {
  'use strict';

  angular
    .module('oresell')
    .factory('ongkir', ongkir);

  function ongkir(APIHandling, $http, $q, $log) {

    this.searchSubdistrict = function (filter) {
      var q = $q.defer();

      APIHandling.get('ongkir/search-kecamatan', filter).then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.listCost = function (data) {
      var q = $q.defer();

      APIHandling.get('ongkir/listcost', data).then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    return this;
  }

})();

(function () {
  'use strict';

  angular
    .module('oresell')
    .factory('inbox', inbox);

  function inbox(APIHandling, $http, $q, $log) {

    // var instance = this;

    this.list = function (filter) {
      var q = $q.defer();

      APIHandling.get('inbox', filter).then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.unread = function () {
      var q = $q.defer();

      APIHandling.get('inbox/unread').then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.get = function (id) {
      var q = $q.defer();

      APIHandling.get('inbox/' + id ).then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.save = function (data) {
      var q = $q.defer();
      var apiCall;

      if (data.id) {
        apiCall = APIHandling.put('inbox', data);
      } else {
        apiCall = APIHandling.post('inbox', data);
      }

      apiCall.then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.delete = function (data) {
      var q = $q.defer();

      APIHandling.delete('inbox', {list_id: data}).then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    return this;
  }

})();

(function () {
  "use strict";

  angular.module("oresell").factory("deposit", deposit);

  function deposit(APIHandling, $http, $q, $log) {
    // var instance = this;

    this.list = function (filter) {
      var q = $q.defer();
      angular.element(".loading-animation").show();

      APIHandling.get("deposit", filter)
        .then(
          function (response) {
            q.resolve(response);
          },
          function (error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function () {
          angular.element(".loading-animation").hide();
        });

      return q.promise;
    };

    // this.get = function(id) {
    //   var q = $q.defer();
    //   angular.element('.loading-animation').show();

    //   APIHandling.get('deposit/' + id)
    //     .then(
    //       function(response) {
    //         q.resolve(response);
    //       },
    //       function(error) {
    //         $log.error(error);
    //         q.reject(error);
    //       }
    //     )
    //     .finally(function() {
    //       angular.element('.loading-animation').hide();
    //     });

    //   return q.promise;
    // };

    this.save = function (data) {
      var q = $q.defer();
      var apiCall;

      if (data.id) {
        apiCall = APIHandling.put("deposit", data);
      } else {
        apiCall = APIHandling.post("deposit", data);
      }

      angular.element(".loading-animation").show();

      apiCall
        .then(
          function (response) {
            q.resolve(response);
          },
          function (error) {
            $log.error(error);
            q.reject(error);
          }
        )
        .finally(function () {
          angular.element(".loading-animation").hide();
        });

      return q.promise;
    };

    return this;
  }
})();

(function () {
  'use strict';

  angular
    .module('oresell')
    .factory('contact', contact);

  function contact(APIHandling, $http, $q, $log) {

    // var instance = this;

    this.list = function (filter, recNewContact) {
      var q = $q.defer();

      APIHandling.get('contact', filter).then(function (response) {

        if (recNewContact) {
          response.data.contact.push({
            id: 0,
            nama: filter.by_name,
            info: 'Buat kontak baru dan gunakan sebagai konsumen'
          });
        }

        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.get = function (id) {
      var q = $q.defer();

      APIHandling.get('contact/' + id ).then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.save = function (data) {
      var q = $q.defer();
      var apiCall;

      if (data.id) {
        apiCall = APIHandling.put('contact', data);
      } else {
        apiCall = APIHandling.post('contact', data);
      }

      apiCall.then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    this.delete = function (data) {
      var q = $q.defer();

      APIHandling.delete('contact', {list_id: data}).then(function (response) {
        q.resolve(response);
      }, function (error) {
        $log.error(error);
        q.reject(error);
      });

      return q.promise;
    };

    return this;
  }

})();

(function () {
  'use strict';

  angular
    .module('oresell')
    .factory('INFOHandling', INFOHandling);

  function INFOHandling(APIHandling, VERSION, BUILD, $q) {
    var instance = this;

    instance.getVersion = function () {

      var defered = $q.defer();

      APIHandling.get('version').then(function (response) {

        defered.resolve({
          server_build: response.data.build
        });

      }, function () {
        defered.reject();
      });

      return defered.promise;
    };

    return instance;
  }

})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .factory('AuthInterceptor', AuthInterceptor);

  /** @ngInject */
  function AuthInterceptor($q, $injector) {
    return {
        'responseError': function (rejection) {

            var invalidToken = false;

            // if (rejection.status === 400) {
            //   invalidToken = true;
            // }

            if (invalidToken || rejection.status === 401) {
                $injector.get('$state').go('login');
            }

            return $q.reject(rejection);
        }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('oresell')
    .factory('AUTHandling', AUTHandling);

  function AUTHandling(APIHandling, store, $state, $q, $timeout) {
    var instance = this;

    instance.login = function (username, password, recapcha) {

      var q = $q.defer();

      APIHandling.post('login', { email: username, password: password, recapcha: recapcha}).then(function (response) {
        instance.saveLoginState(response.data);
        q.resolve(response);
      }, function (error) {
        q.reject(error);
      });

      return q.promise;
    };

    instance.cleanLoginState = function () {
      store.remove('token');
      store.remove('user');
    };

    instance.saveLoginState = function (loginData) {

      // loginData.data.user.detail = angular.fromJson(loginData.data.user.detail);

      store.set('oresell_token', loginData.token);
      store.set('oresell_user', loginData.user);
    };

    instance.updateProfile = function (data) {
      return APIHandling.post('update-profile', data);
    };

    instance.requestResetPassword = function (data) {
      return APIHandling.post('request-reset-password', data);
    };

    instance.resetPassword = function (data) {
      return APIHandling.post('reset-password', data);
    };

    instance.setLocalUserData = function (data) {

      store.set('oresell_user', data);
    };

    instance.logout = function () {

      /** Tunda proses clean login data agar data JWT masih tersedia ketika userlog.save dijalankan */
      $timeout(function () {
        instance.cleanLoginState();
        $state.go('login');
      }, 10);

    };

    instance.checkToken = function () {
      var q = $q.defer();

      APIHandling.get('check-token', null).then(function (response) {
        q.resolve(response);
      }).catch(function (error) {
        q.reject(error);
      });

      return q.promise;
    };

    return instance;
  }

})();

(function() {
  'use strict';

  angular.module('oresell').factory('APIHandling', APIHandling);

  function APIHandling(
    $http,
    store,
    $q,
    $timeout,
    PROTOCOL,
    APIDOMAIN,
    BASEURL,
    TIMEOUT
  ) {
    var instance = this;

    /* Batas timeout http request, dalam ms */
    this.timeOutLimit = TIMEOUT;

    /* baseURL API Call */
    this.baseURL = PROTOCOL + '://' + APIDOMAIN + BASEURL;

    this.httpRequest = function(method, endpoint, data, params) {
      /* Set timeout dan result sebagai promise */
      var timeout = $q.defer();
      var result = $q.defer();

      /* Set status timeout */
      var isTimeOut = false;

      /* Set timeout untuk resolve dalam jangka waktu yang ditentukan, yaitu timeOutLimit */
      $timeout(function() {
        /* Set status timeout menjadi true jika promise timeout resolved */
        isTimeOut = true;
        timeout.resolve();
      }, instance.timeOutLimit);

      /* Lakukan http request, set timeout terjadi ketika promise timeout resolved, yaitu pada saat timeOutLimit */
      // angular.element('.loading-animation').show();
      var req = $http({
        method: method,
        url: instance.baseURL + endpoint,
        data: data,
        params: params,
        paramSerializer: '$httpParamSerializerJQLike',
        timeout: instance.timeOutLimit,
        headers: {
          Accept: 'application/json;charset=utf-8',
          'Content-Type': 'application/json;charset=utf-8'
        }
      });

      req.then(
        function(response) {
          return result.resolve(response);
        },
        function(error) {
          /**
           *  Jika status timeout === true, maka request belum dapat balasan saat timeout resolved, berarti request belum dapat response melebihi
           *  waktu timeout yang kita sediakan. Maka set response error dengan status 408 Request Timeout
           **/
          if (isTimeOut) {
            result.reject({
              status: 408,
              statusText: 'Request Timeout',
              data: {
                message:
                  'Proses lebih lama dari ' +
                  instance.timeOutLimit / 1000 +
                  ' detik dan belum mendapat balasan. Batalkan'
              }
            });
          } else {
            result.reject(error);
          }
        }
      ).finally(function () {
        // angular.element('.loading-animation').hide();
      });

      return result.promise;
    };

    this.get = function(endpoint, params) {
      return instance.httpRequest('GET', endpoint, null, params);
    };

    this.post = function(endpoint, data) {
      return instance.httpRequest('POST', endpoint, data);
    };

    this.put = function(endpoint, data) {
      return instance.httpRequest('PUT', endpoint, data);
    };

    this.delete = function(endpoint, data) {
      return instance.httpRequest('DELETE', endpoint, null, data);
    };

    this.getInfoServer = function() {
      return $http.get(instance.baseURL + 'info');
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular
    .module("oresell")
    .controller("ViewDepositTicketController", ViewDepositTicketController);

  /** @ngInject */
  function ViewDepositTicketController(
    $uibModalInstance,
    $timeout,
    moment,
    store,
    topup,
    $log,
    data,
    toastr,
    $window
  ) {
    var vm = this;

    vm.depositData = data;
    vm.disabled = false;
    vm.checkConfirm = false;

    vm.retry = 0;

    vm.confirmTransfer = function () {
      topup.confirm(vm.depositData).then(
        function (response) {
          $log.log(response);
          toastr.success(
            "Pembayaran Anda sudah kami terima. Deposit Anda otomatis ditambahkan",
            "Transfer Terkonfirmasi"
          );
          vm.depositData = response.data;
        },
        function (error) {
          $log.error(error);
          if (error.status === 428) {
            // $window.sessionStorage.setItem('oresell_qticket_id', error.data.data.ticket.id);
            toastr.info(
              "Sistem akan otomatis mengecek deposit Anda. Jika dalam 15 menit deposit belum masuk, harap hubungi Admin",
              "Konfirmasi Kami Terima"
            );
          } else if (error.status === 409) {
            toastr.error(
              "Anda baru saja konfirmasi transfer yang sama persis dg sebelumnya.",
              "Posting berulang"
            );
          } else if (error.status === 410) {
            toastr.error(
              "Tiket tidak ada, sudah terkonfirmasi, atau sudah dibatalkan.",
              "Tiket tidak ditemukan"
            );
          } else if (error.status === 411) {
            toastr.error(
              "Server tidak mendeteksi transfer Anda. Silahkan ulangi konfirmasi 5 menit lagi",
              "Transfer belum kami terima"
            );
          } else if (error.status === 408) {
            toastr.error(
              "Sistem gagal mengecek transfer. ERROR 408",
              "Gagal mengecek transfer"
            );
          } else if (error.status === 409) {
            toastr.error(
              "Sistem gagal mengecek transfer. ERROR 409",
              "Gagal mengecek transfer"
            );
          } else if (error.status === 503) {
            toastr.error(
              "Sistem gagal mengecek transfer. ERROR 503",
              "Gagal mengecek transfer"
            );
          } else {
            toastr.error(
              "Terjadi kesalahan saat konfirmasi transfer deposit",
              "Terjadi Kesalahan"
            );
          }

          vm.disabled = true;
          vm.retry = vm.retry + 1;

          var to = 300000;

          if (vm.retry >= 3) {
            to = 864000000;
          }

          $timeout(function () {
            vm.disabled = false;
          }, to);

          var m = moment().add(to/60000, "m").valueOf();
          store.set("oresell_next_confirm_" + vm.depositData.bank.toLowerCase(), m);
          $window.sessionStorage.setItem('oresell_topup_retry_' + vm.depositData.id, vm.retry);
        }
      );
    };

    vm.batal = function () {
      $uibModalInstance.dismiss("batal");
    };

    vm.initView = function () {
      var m = store.get("oresell_next_confirm_" + vm.depositData.bank.toLowerCase());

      if (m) {
        var now = Date.now();

        var w = m * 1 - now;
        if (w > 0) {
          vm.disabled = true;
          $timeout(function () {
            vm.disabled = false;
          }, w);
        }
      }

      vm.retry = $window.sessionStorage.getItem('oresell_topup_retry_' + vm.depositData.id);
      if (!vm.retry) {
        vm.retry = 0;
      } else {
        vm.retry = parseInt(vm.retry);
      }
    };

    vm.initView();
  }
})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('UserProfileController', UserProfileController);

  /** @ngInject */
  function UserProfileController($uibModalInstance, _, $log, AUTHandling, contact, ongkir, toastr, data) {
    var vm = this;
    vm.user = {};

    vm.invalidPassword = function () {
      if (vm.user.password !== vm.user.confirm_password) {
        return true;
      } else {
        return false;
      }
    };

    vm.alamat = {
      source: {
        kecamatan: []
      },
      provinsi: null,
      kabupaten: null,
      kecamatan: null,

      validasi: {
        nomor: /^(([A-z][0-9]+)|([0-9]+))$/
      }
    };


    vm.finish = function () {

      vm.user.contact.nama = vm.user.auth.name;
      vm.user.contact.email = vm.user.auth.email;

      if (vm.alamat.kabupaten) {
        vm.user.contact.prov = vm.alamat.kabupaten.province;
        vm.user.contact.prov_id = vm.alamat.kabupaten.province_id;
        vm.user.contact.kab = vm.alamat.kabupaten.type + ' ' + vm.alamat.kabupaten.city_name;
        vm.user.contact.kab_id = vm.alamat.kabupaten.city_id;
      }

      if (vm.alamat.kecamatan) {
        vm.user.contact.kec = vm.alamat.kecamatan.subdistrict_name;
        vm.user.contact.kec_id = vm.alamat.kecamatan.subdistrict_id;
      }

      if (!vm.user.contact.extra) {
        vm.user.contact.extra = {};
      }

      vm.user.contact.telp = vm.user.contact.telp || '';
      vm.user.contact.kode_pos = vm.user.contact.kode_pos || '';

      vm.user.auth.phone = vm.user.contact.hp;

      /** Kalau password kosong, pastikan null */
      if (!vm.user.auth.password) {
        vm.user.auth.password = null;
        vm.user.auth.confirm_password = null;
      }

      AUTHandling.updateProfile(vm.user).then( function (response) {

        toastr.success('Berhasil simpan data user', 'Berhasil simpan');
        vm.user.auth.contact_id = response.data.id;
        AUTHandling.setLocalUserData(vm.user.auth);
        $uibModalInstance.close(vm.user.auth);
      }, function (error) {
        $log.debug(error);
        toastr.error('Gagal simpan data user', 'Gagal simpan');
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

    vm.initView = function () {
      var user = _.cloneDeep(data);

      vm.user = {
        auth: user,
        contact: {}
      };

      vm.user.auth.password = null,
      vm.user.auth.confirm_password = null;

      if (vm.user.auth.contact_id) {
        contact.get(vm.user.auth.contact_id).then(function (response) {
          vm.user.contact = _.cloneDeep(response.data);


          if ((vm.user.contact.prov_id !== 0) && (vm.user.contact.kab_id !== 0) && (vm.user.contact.kec_id !== 0)) {

            ongkir.searchSubdistrict({ id: vm.user.contact.kec_id }).then(function (response) {
              vm.alamat.kecamatan = response.data[0];
            });
          }

          if (vm.user.contact.extra === '[]') {
            vm.user.contact.extra = {};
          } else {
            vm.user.contact.extra = angular.fromJson(
              vm.user.contact.extra
            );
          }
        });
      } else {
        vm.user.contact = {
          kelamin: 'P',
          hp: user.phone
        };
      }
    };

    vm.searchSubdistrict = function (search) {
      ongkir.searchSubdistrict({ name: search }).then(function (response) {
        vm.alamat.source.kecamatan = response.data;
      });
    };

    vm.initView();
  }

})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('UserDialogController', UserDialogController);

  /** @ngInject */
  function UserDialogController($uibModalInstance, user, _, data, $log, toastr) {
      var vm = this;
      vm.isEdit = false;

      if (data) {
        vm.user = _.cloneDeep(data);
        vm.user.type = data.type.toString();
        vm.isEdit = true;
      } else {
        vm.user = {
          username: null,
          email: null,
          data: {
            name: null
          },
          password: null,
          confirm_password: null,
          type: 'ADMIN'
        };
      }

      vm.cancel = function () {
          $uibModalInstance.close();
      };

      vm.addUser = function () {

        if (vm.user.password === vm.user.confirm_password) {

          var proses = null;

          if (data) {
            proses = user.put(vm.user);
          } else {
            proses = user.post(vm.user);
          }

          proses.then(function (response) {
            if (response.status === 200) {
              toastr.success('Data user berhasil disimpan', 'Sukses');
              $uibModalInstance.close();
            }
          }, function (error) {
            $log.error(error);
            toastr.error('Gagal menyimpan data user', 'Gagal');
          });
        } else {
          toastr.error('Password dan Konfirmasi Password tidak cocok', 'Gagal');
        }

      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('TransactionDetailDialogController', TransactionDetailDialogController);

  /** @ngInject */
  function TransactionDetailDialogController($uibModalInstance, _, $log, transaction, data, toastr) {
      var vm = this;
      vm.id = data;

      vm.initView = function () {

        transaction.get( vm.id).then( function (response) {

          var map = [];
          var produk_jual = [];
          vm.transaksi = response.data;

          /* Data lain_lain dalam bentuk JSON, perlu diparse agar bisa diproses */
          vm.transaksi.lain_lain = angular.fromJson(vm.transaksi.lain_lain);

          /* Siapkan array untuk menyimpan data produk unik */
          vm.transaksi.produk_unik = [];

          _.each(response.data.produk_jual, function (item) {

            var index = _.indexOf(map, item.produk_id);

            if ( index < 0 ) {
              map.push(item.produk_id);


              var detail = angular.fromJson(item.detail);

              if (detail.attributes) {
                item.ukuran = _.find(detail.attributes, function (o) {
                  return o.name === 'SIZE';
                });
              } else {
                item.ukuran = _.find(detail, function (o) {
                  return o.name === 'SIZE';
                });
              }


              produk_jual.push(item);
            } else {
              produk_jual[index].jumlah = (produk_jual[index].jumlah * 1) + (item.jumlah * 1);
              produk_jual[index].discount_persen = (produk_jual[index].discount_persen * 1) + (item.discount_persen * 1);
              produk_jual[index].discount_nominal = (produk_jual[index].discount_nominal * 1) + (item.discount_nominal * 1);
            }
          });

          vm.transaksi.produk_unik = produk_jual;
          vm.transaksi.lain_lain = angular.fromJson(vm.transaksi.lain_lain);

          // $log.debug(vm.transaksi);

        }, function (error) {
          $log.error(error);
          toastr.error('Terjadi kesalahan saat mengambil data transaksi', 'Gagal');
        });
      };

      vm.batal = function () {
        $uibModalInstance.dismiss('batal');
      };

      vm.initView();

  }

})();

(function () {
  "use strict";

  angular
    .module("oresell")
    .controller("ProcessOrderDialogController", ProcessOrderDialogController);

  /** @ngInject */
  function ProcessOrderDialogController(
    $uibModalInstance,
    $scope,
    $q,
    $log,
    order,
    user,
    transaction,
    contact,
    ongkir,
    product,
    toastr,
    moment,
    _,
    settings
  ) {
    var vm = this;

    vm.inProgress = false;

    vm.order = order;
    vm.produk_jual = _.cloneDeep(order.produk_jual);
    vm.currStep = 0;
    vm.onlyNumbers = /^\d+$/;
    vm.waitNext = true;
    vm.user = user.getData();
    vm.itemNotEnoughStock = [];
    vm.dataReseller = null;
    vm.balance = 0;
    vm.lastBalance = 0;
    vm.customerNote = "";
    vm.jobNumber = "";
    vm.asuransi = 0;
    vm.ekspedisiMP = "";
    vm.ekspedisiMPOther = "";

    vm.resume = {
      totalQty: 0,
      totalPrice: 0,
      deliveryCost: 0,
      total: 0,
      originalPrice: 0,
      originalQty: 0,
      deletedItemFine: 0,
      totalFine: 0,
      totalWeight: 0,
    };

    vm.calculateResume = function () {
      vm.resume.totalQty = 0;
      vm.resume.totalPrice = 0;
      vm.resume.totalWeight = 0;

      _.each(vm.produk_jual, function (n) {
        vm.resume.totalQty = vm.resume.totalQty + n.jumlah * 1;
        vm.resume.totalPrice =
          vm.resume.totalPrice + n.harga_diskon * 1 * (n.jumlah * 1);

        vm.resume.totalWeight =
          vm.resume.totalWeight + n.weight * 1000 * n.jumlah;
      });
    };

    vm.calculateFine = function () {
      var deltaQty = 0;

      _.each(vm.produk_jual, function (n) {
        deltaQty = n.jumlah - n.originalQty;

        if (deltaQty < 0) {
          n.fine = -deltaQty * vm.settings.fine;
        } else {
          n.fine = 0;
        }
      });

      vm.resume.totalFine =
        vm.resume.deletedItemFine + _.sumBy(vm.produk_jual, "fine");
    };

    vm.changeItemQty = function (item) {
      vm.calculateResume();

      function saldoTidakCukup() {
        item.jumlah = item.jumlah - 1;
        vm.calculateResume();
        toastr.error("Saldo deposit tidak cukup", "Deposit tidak cukup");
      }

      if (!order.id) {
        if (vm.resume.totalPrice >= vm.user.balance * 1) {
          saldoTidakCukup();
        }
        $scope.$emit("CHANGEQTY", item);
      } else {
        var deltaPrice = vm.resume.totalPrice - vm.resume.originalPrice;

        if (deltaPrice > vm.user.balance * 1) {
          saldoTidakCukup();
        }

        vm.calculateFine();
      }

      item.stock = item.real_stock - item.jumlah;
      // var maxQty = item.real_stock;

      if (order.id > 1) {
        item.stock = item.real_stock + item.originalQty - item.jumlah;
      }

      if (item.stock < 0) {
        item.noStock = true;

        var isExist = _.find(vm.itemNotEnoughStock, function (n) {
          return n === item.id;
        });

        if (!isExist) {
          vm.itemNotEnoughStock.push(item.id);
        }
      } else {
        item.noStock = false;
        vm.itemNotEnoughStock.splice(vm.itemNotEnoughStock.indexOf(item.id), 1);
      }

      if (vm.itemNotEnoughStock.length === 0) {
        vm.waitNext = false;
      } else {
        vm.waitNext = true;
      }
    };

    vm.getCustomerContact = function (filter, filterIsID) {
      vm.inProgress = true;

      var search;

      if (filterIsID) {
        search = {
          by_id: filter,
        };
      } else {
        search = {
          by_name: filter,
        };
      }

      contact.list(search, true).then(function (response) {
        vm.contactList = response.data.contact;

        if (order.id > 0) {
          vm.selectedContact = _.find(vm.contactList, function (n) {
            return n.id === order.cust_uuid;
          });
          vm.waitNext = false;
        }
        vm.inProgress = false;
      });
    };

    vm.changeCustomer = function () {
      if (vm.selectedContact.id === 0) {
        vm.newContact.nama = vm.selectedContact.nama;
        /** Event ini mentrigger hilangkan info data ongkir */
        vm.optionOngkir = null;
        vm.selectedCost = null;
      } else {
        /** Even ini mentrigger proses ambil data ongkir */
        vm.optionOngkir = null;
        vm.selectedCost = null;
        vm.getCost();
      }

      vm.waitNext = true;
    };

    vm.searchSubdistrict = function (search) {
      vm.inProgress = true;
      ongkir.searchSubdistrict({ name: search }).then(function (response) {
        vm.listKecamatan = response.data;
        vm.inProgress = false;
      });
    };

    vm.saveNewContact = function () {
      vm.inProgress = true;

      vm.newContact.prov = vm.selectedKec.province;
      vm.newContact.prov_id = vm.selectedKec.province_id;
      vm.newContact.kab = vm.selectedKec.city;
      vm.newContact.kab_id = vm.selectedKec.city_id;
      vm.newContact.kec = vm.selectedKec.subdistrict_name;
      vm.newContact.kec_id = vm.selectedKec.subdistrict_id;
      vm.newContact.extra = {};

      vm.newContact.email = vm.newContact.email || "";
      vm.newContact.hp = vm.newContact.hp || "";
      vm.newContact.telp = vm.newContact.telp || "";
      vm.newContact.alamat = vm.newContact.alamat || "";
      vm.newContact.kode_pos = vm.newContact.kode_pos || "";

      contact.save(vm.newContact).then(
        function (response) {
          vm.inProgress = false;
          vm.selectedContact = _.cloneDeep(response.data);
          vm.waitNext = false;

          /** Event ini trigger ambil data ongkir */
          vm.optionOngkir = null;
          vm.selectedCost = null;
          vm.getCost();
        },
        function (error) {
          vm.inProgress = false;
          toastr.error(error, "Gagal simpan kontak");
        }
      );
    };

    vm.cancelNewContact = function () {
      vm.newContact = {};
      vm.newContact.kelamin = "P";

      if (order.id > 0) {
        vm.getCustomerContact(order.pembeli);
        /** Event ini trigger ambil data ongkir */
        vm.optionOngkir = null;
        vm.selectedCost = null;
        vm.getCost();
      } else {
        vm.selectedContact = vm.originalSelectedContact;
      }
    };

    vm.editContact = function () {
      vm.newContact = _.cloneDeep(vm.selectedContact);
      vm.originalSelectedContact = _.cloneDeep(vm.selectedContact);
      vm.selectedContact.id = 0;
      vm.waitNext = true;

      if (
        vm.newContact.prov_id !== 0 &&
        vm.newContact.kab_id !== 0 &&
        vm.newContact.kec_id !== 0
      ) {
        vm.inProgress = true;
        ongkir
          .searchSubdistrict({ id: vm.newContact.kec_id })
          .then(function (response) {
            vm.selectedKec = response.data[0];
            vm.inProgress = false;
          });
      }
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    };

    vm.getCostData = function (stage, courier) {
      /**
       * Berat tidak usah dibulatkan
       */
      // var weight = vm.resume.totalWeight * 1000;
      var weight = vm.resume.totalWeight;

      var ongkirKab = ongkir.listCost({
        weight: weight,
        dest_kab: vm.selectedContact.kab_id,
        courier: courier || null,
      });

      var ongkirKec = ongkir.listCost({
        weight: weight,
        dest_kab: vm.selectedContact.kab_id,
        dest_kec: vm.selectedContact.kec_id,
        courier: courier || null,
      });

      $q.all([ongkirKab, ongkirKec]).then(
        function (response) {
          vm.inProgress = false;
          var data = _.cloneDeep(response[0].data.results);
          var dataKec = _.cloneDeep(response[1].data.results);

          vm.statusOngkir = stage;

          _.each(dataKec, function (o) {
            if (o.costs.length > 0) {
              /** Dapatkan index data di ongkir kab yang sama dengan ongkir kec ini */
              var i = _.findIndex(data, function (n) {
                return n.code === o.code;
              });

              /** Replace data ongkir kab dengan ongkir kec ini */
              data[i] = _.cloneDeep(o);
            }
          });

          _.each(data, function (o) {
            if (o.costs.length > 0) {
              /** Sorting internal ekspedisi */
              o.costs = _.sortBy(o.costs, [
                function (i) {
                  return i.cost[0].value;
                },
              ]);

              /** Hanya tampilkan ekspedisi yang ada data ongkirnya */
              vm.ongkir.push(o);
            }
          });
        },
        function () {
          vm.inProgress = false;
          vm.statusOngkir = -1;
          // toastr.error(error, 'Gagal ambil data ongkir')
        }
      );
    };

    vm.getCost = function () {
      vm.inProgress = true;

      vm.ongkir = [];
      vm.statusOngkir = 0;

      vm.getCostData(1);
    };

    vm.getMoreExpedition = function () {
      vm.getCostData(2, ["ide"]);
    };

    vm.setShippingCost = function (ongkir) {
      vm.selectedCost = _.cloneDeep(ongkir);
      vm.waitNext = false;
    };

    vm.nextStep = function () {
      vm.currStep = vm.currStep + 1;

      if (vm.currStep === 1) {
        vm.optionOngkir = null;
        vm.selectedCost = null;
        vm.waitNext = true;

        if (vm.selectedContact && vm.selectedContact.id !== 0) {
          vm.getCost();
        }
      } else if (vm.currStep === 2) {
        vm.calculateResume();

        vm.resume.deliveryCost = vm.selectedCost.service.cost[0].value * 1;
        vm.resume.total = vm.resume.totalPrice + vm.resume.deliveryCost;

        if (vm.selectedCost.name === "pos") {
          vm.asuransi = 500;
          vm.resume.total = vm.resume.total + vm.asuransi;
        } else {
          vm.asuransi = 0;
        }

        /**
         * Last balance dihitung dari balance dikurangi total_akhir trx.
         * Tidak ada bedanya antara trx biasa ataupun trx pending karena
         * balance awal sudah disesuaikan saat inisialisasi.
         * */
        vm.lastBalance = vm.balance - vm.resume.total;
      }
    };

    vm.prevStep = function () {
      vm.currStep = vm.currStep - 1;
      vm.waitNext = false;
    };

    vm.deleteItem = function (index, item) {
      vm.produk_jual.splice(index, 1);
      vm.calculateResume();
      $scope.$emit("REMOVEITEM", { index: index, item: item });

      if (order.id) {
        vm.resume.deletedItemFine = item.originalQty * vm.settings.fine;
        vm.calculateFine();
      }

      if (vm.produk_jual.length === 0) {
        vm.cancel();
      }
    };

    vm.clearAll = function () {
      // vm.produk_jual.splice(index, 1);
      $scope.$emit("CLEARALLITEM");
      vm.cancel();
    };

    vm.saveTransaction = function (isPending) {
      vm.inProgress = true;

      var trxDate = moment().format("YYYY-MM-DD HH:mm:ss");

      var payload = {
        order: {
          cust_uuid: vm.selectedContact.id,
          discount_nominal: 0,
          discount_persen: 0,
          discount_total: 0,
          lain_lain: {
            biaya_lain: vm.asuransi,
            dropship: {
              isDropship: true,
              sender: vm.dataReseller,
              customSender: vm.customSender,
            },
            hp: vm.selectedContact.hp,
            email: vm.selectedContact.email,
            customerNote: vm.customerNote,
            jobNumber: vm.jobNumber,
            ekspedisiMP: vm.ekspedisiMP,
            ekspedisiMPOther: vm.ekspedisiMPOther,
          },
          pembeli: vm.selectedContact.nama,
          shipping_alamat: vm.selectedContact.alamat,
          shipping_kab: vm.selectedContact.kab,
          shipping_kab_id: vm.selectedContact.kab_id,
          shipping_kec: vm.selectedContact.kec,
          shipping_kec_id: vm.selectedContact.kec_id,
          shipping_prov: vm.selectedContact.prov,
          shipping_prov_id: vm.selectedContact.prov_id,
          tgl: trxDate,
          total: vm.resume.totalPrice,
          total_akhir: vm.resume.total,
          total_lain_lain: vm.resume.deliveryCost + vm.asuransi,
          ekspedisi: vm.selectedCost.name,
          ekspedisi_service: vm.selectedCost.service.service,
          ongkir: vm.resume.deliveryCost,
        },
        produk_jual: vm.produk_jual,
        pembayaran: [],
      };

      if (vm.asuransi > 0) {
        payload.order.lain_lain.biaya = [
          {
            id: 0,
            jenis: "lain",
            nilai: vm.asuransi,
            ket: "Asuransi",
          },
        ];
      }

      payload.pembayaran.push({
        id: 0,
        tgl: trxDate,
        metode_bayar: "DEPOSIT",
        nominal: vm.resume.total,
        ket: "Oresell",
      });

      payload.order.bayar = payload.order.total_akhir;
      payload.order.sisa_kembali = 0;

      if (isPending) {
        payload.order.status = "pending";
      } else {
        payload.order.status = "dibayar";
      }

      if (order.id > 0) {
        payload.order.id = order.id;
      }

      transaction.save(payload).then(
        function (response) {
          toastr.success("Berhasil simpan transaksi", "Sukses");

          if (payload.order.id > 0) {
            $scope.$emit("FINISHPENDING", response.data);
          } else {
            $scope.$emit("FINISHORDER", response.data);
          }

          vm.inProgress = false;
          $uibModalInstance.close();
        },
        function (error) {
          if (error.status === 409) {
            toastr.error("Jumlah stok tidak cukup", "Gagal");
            vm.currStep = 0;
            vm.verifyProductStock();
          } else if (error.status === 406) {
            toastr.error("Deposit tidak cukup", "Gagal");
            vm.currStep = 0;
          } else {
            toastr.error("Gagal simpan transaksi", "Gagal");
          }

          vm.inProgress = false;
        }
      );
    };

    vm.verifyProductStock = function () {
      vm.inProgress = true;
      var list_id = _.map(vm.produk_jual, "id");

      /**
       * Set per page, beri nilai yg agak besar, misal 100
       * Asalnya diset default, yaitu 10, ternyata bikin bug ketika jumlah item
       * di cart lebih dari 10.
       * Bisa dibilang bukan bug, karena verifikasi produk jadi gagal, sehingga
       * waitNext tentu menjadi true
       */
      product.list({ list_produk_id: list_id, per_page: 100 }).then(
        function (response) {
          vm.inProgress = false;
          _.each(vm.produk_jual, function (n) {
            var item = _.find(response.data.data, { id: n.id });

            n.real_stock = item.jumlah;
            n.stock = item.jumlah - n.jumlah;

            if (item.jumlah < n.jumlah) {
              n.noStock = true;
              vm.itemNotEnoughStock.push(item.id);
            }
          });

          if (vm.itemNotEnoughStock.length > 0) {
            vm.waitNext = true;
          } else {
            vm.waitNext = false;
          }
        },
        function () {
          vm.inProgress = false;
          toastr.error("Gagal cek stok produk", "Gangguan");
        }
      );
    };

    vm.initView = function () {
      vm.inProgress = true;
      /** Ambil data balance deposit user */
      user.checkBalance().then(
        function (response) {
          vm.balance = response.data.balance * 1;
          vm.inProgress = false;
        },
        function (error) {
          vm.inProgress = false;
          $log.error(error);
          toastr.error(
            "Gagal mengecek data saldo deposit. Tutup dialog ini dan coba lagi",
            "Gagal cek saldo"
          );
        }
      );

      /** Ambil data kontak user untuk disimpan di transaksi */
      contact.get(vm.user.contact_id).then(
        function (response) {
          vm.dataReseller = response.data;
          vm.inProgress = false;
        },
        function (error) {
          vm.inProgress = false;
          vm.dataReseller = {
            hp: vm.user.phone,
          };

          $log.warn(error);
          toastr.warning(
            "Anda belum mengisi profil. Klik nama anda di pojok kanan atas dan lengkapi profil sebelum transaksi.",
            "Peringatan",
            { timeOut: 0 }
          );
        }
      );

      if (order.id > 0) {
        vm.inProgress = true;
        transaction.get(order.id).then(function (response) {
          vm.inProgress = false;
          /** Produk jual perlu dibikin unik, karena perlakuan dari POS */
          vm.produk_jual = _.chain(response.data.produk_jual)
            .groupBy("produk_id")
            .map(function (object) {
              var a = _.last(object);

              a.discount_persen = _.sumBy(object, function (n) {
                return n.discount_persen * 1;
              });
              a.jumlah = _.sumBy(object, "jumlah");
              return a;
            })
            .value();

          _.each(vm.produk_jual, function (n) {
            // n.harga_diskon = n.harga_jual - ((n.discount_persen/100) * n.harga_jual);
            n.harga = n.harga_jual * 1;
            n.discount_total =
              (n.discount_persen / 100) * n.harga_jual * n.jumlah;
            n.harga_diskon = n.harga_jual - n.discount_total / n.jumlah;
            n.detail = angular.fromJson(n.detail);
            // n.maxQty = n.jumlah + n.current_stok;
            n.originalQty = n.jumlah;
            n.fine = 0;
            n.real_stock = n.current_stok;
            n.stock = n.current_stok;

            n.family = _.find(n.detail.attributes, function (o) {
              return o.name === "FAMILY";
            });
          });

          vm.calculateResume();
          vm.resume.originalPrice = vm.resume.totalPrice;
          vm.resume.originalQty = vm.resume.totalQty;

          /**
           * Jika transaksi pending, maka balance adalah nilai balance
           * terakhir, ditambah nilai total_akhir transaksi.
           * */
          vm.balance = vm.balance + response.data.total_akhir * 1;

          response.data.lain_lain = angular.fromJson(response.data.lain_lain);

          if (response.data.lain_lain.dropship.customSender) {
            response.data.lain_lain.dropship.customSender.use =
              response.data.lain_lain.dropship.customSender.use === "0"
                ? false
                : true;
          }
          vm.customSender = response.data.lain_lain.dropship.customSender;

          vm.customerNote = response.data.lain_lain.customerNote;
        });
        vm.getCustomerContact(order.cust_uuid, true);
      } else {
        vm.verifyProductStock();
        vm.calculateResume();
      }

      /** Ambil data setting, untuk mendapatkan nilai denda */
      settings.getBase().then(
        function (response) {
          vm.inProgress = false;
          vm.settings = response.data.value;
        },
        function (error) {
          vm.inProgress = false;
          $log.error(error);
          toastr.error("Gagal mengambil setting denda. Coba lagi", "Error");
        }
      );
    };

    vm.initView();
  }
})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MassDeleteContactDialogController', MassDeleteContactDialogController);

  /** @ngInject */
  function MassDeleteContactDialogController($uibModalInstance,  $log, contact, toastr, data) {
      var vm = this;
      vm.contact = data;

      vm.finish = function () {

        contact.delete(vm.contact).then( function () {
          toastr.success('Berhasil menghapus data kontak', 'Sukses hapus');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal menghapus data kontak', 'Gagal hapus');
          $uibModalInstance.dismiss('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('EditContactDialogController', EditContactDialogController);

  /** @ngInject */
  function EditContactDialogController($uibModalInstance,  _, $log, toastr, contact, ongkir, data) {
      var vm = this;
      vm.contact = {};
      vm.alamat = {
        source: {
          kecamatan: []
        },
        provinsi: null,
        kabupaten: null,
        kecamatan: null,

        validasi: {
          nomor: /^(([A-z][0-9]+)|([0-9]+))$/
        }
      };

      if (_.isUndefined(data)) {
        /** Jika data baru maka init kosong */
        vm.contact = {
          nama: null,
          email: null,
          hp: null,
          telp: null,
          alamat: null,
          prov: null,
          prov_id: 0,
          kab: null,
          kab_id: 0,
          kec: null,
          kec_id: 0,
          kode_pos: null,
          kelamin: 'P',
          extra: {
            keterangan: null
          }
        };
      } else {
        /** Jika data lama, maka init dari data yang sudah ada */
        vm.contact = _.cloneDeep(data);

        if ((vm.contact.prov_id !== 0) && (vm.contact.kab_id !== 0) && (vm.contact.kec_id !== 0))  {

          ongkir.searchSubdistrict({ id: vm.contact.kec_id }).then(function (response) {
            vm.alamat.kecamatan = response.data[0];
          });

        }

        vm.contact.extra = angular.fromJson(vm.contact.extra);

        if (vm.contact.extra.length === 0) {
          vm.contact.extra = {
            keterangan: null
          };
        }

      }

      vm.save = function () {

        if (vm.alamat.kecamatan) {
          vm.contact.prov = vm.alamat.kecamatan.province;
          vm.contact.prov_id = vm.alamat.kecamatan.province_id;
          vm.contact.kab = vm.alamat.kecamatan.type + ' ' + vm.alamat.kecamatan.city;
          vm.contact.kab_id = vm.alamat.kecamatan.city_id;
          vm.contact.kec = vm.alamat.kecamatan.subdistrict_name;
          vm.contact.kec_id = vm.alamat.kecamatan.subdistrict_id;
        }

        if (!vm.contact.extra) {
          vm.contact.extra = {};
        }

        vm.contact.email = vm.contact.email || '';
        vm.contact.hp = vm.contact.hp || '';
        vm.contact.telp = vm.contact.telp || '';
        vm.contact.alamat = vm.contact.alamat || '';
        vm.contact.kode_pos = vm.contact.kode_pos || '';

        contact.save(vm.contact).then( function () {
          toastr.success('Berhasil simpan data kontak', 'Berhasil simpan');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal simpan data kontak', 'Gagal simpan');
          // $uibModalInstance.dismiss('batal');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

      vm.searchSubdistrict = function (search) {
        ongkir.searchSubdistrict({ name: search }).then(function (response) {
          vm.alamat.source.kecamatan = response.data;
        });
      };

  }

})();

(function () {
  "use strict";

  angular
    .module("oresell")
    .controller("DepositTicketController", DepositTicketController);

  /** @ngInject */
  function DepositTicketController(
    $uibModalInstance,
    $timeout,
    moment,
    store,
    topup,
    $log,
    toastr,
    $window
  ) {
    var vm = this;

    vm.depositValue;
    vm.depositBank;
    vm.depositData;
    vm.disabled = false;
    vm.checkConfirm = false;
    vm.onlyNumbers = /^\d+$/;

    vm.retry = 0;

    vm.createDeposit = function () {
      /**
       * Call API untuk simpan deposit, kemudian tampilkan info tagihan
       * lengkap dg angka unik, dan no rekening untuk pembayaran
       */

      topup.save(vm.depositValue, vm.depositBank).then(
        function (response) {
          vm.depositData = response.data;
        },
        function (error) {
          $log.error(error);
          if (error.status === 409) {
            toastr.error(
              "Anda baru saja membuat tiket yang sama persis dg sebelumnya.",
              "Posting berulang"
            );
          } else {
            toastr.error(
              "Terjadi kesalahan saat membuat tiket topup deposit",
              "Terjadi Kesalahan"
            );
          }
        }
      );
    };

    vm.confirmTransfer = function () {
      topup.confirm(vm.depositData).then(
        function (response) {
          $log.log(response);
          toastr.success(
            "Pembayaran Anda sudah kami terima. Deposit Anda otomatis ditambahkan",
            "Transfer Terkonfirmasi"
          );
          vm.depositData = response.data;
        },
        function (error) {
          $log.error(error);
          if (error.status === 428) {
            // $window.sessionStorage.setItem('oresell_qticket_id', error.data.data.ticket.id);
            toastr.info(
              "Sistem akan otomatis mengecek deposit Anda. Jika dalam 15 menit deposit belum masuk, harap hubungi Admin",
              "Konfirmasi Kami Terima"
            );
          } else if (error.status === 409) {
            toastr.error(
              "Anda baru saja konfirmasi transfer yang sama persis dg sebelumnya.",
              "Posting berulang"
            );
          } else if (error.status === 410) {
            toastr.error(
              "Tiket tidak ada, sudah terkonfirmasi, atau sudah dibatalkan.",
              "Tiket tidak ditemukan"
            );
          } else if (error.status === 411) {
            toastr.error(
              "Server tidak mendeteksi transfer Anda. Silahkan ulangi konfirmasi 5 menit lagi",
              "Transfer belum kami terima"
            );
          } else if (error.status === 408) {
            toastr.error(
              "Sistem gagal mengecek transfer. ERROR 408",
              "Gagal mengecek transfer"
            );
          } else if (error.status === 409) {
            toastr.error(
              "Sistem gagal mengecek transfer. ERROR 409",
              "Gagal mengecek transfer"
            );
          } else if (error.status === 503) {
            toastr.error(
              "Sistem gagal mengecek transfer. ERROR 503",
              "Gagal mengecek transfer"
            );
          } else {
            toastr.error(
              "Terjadi kesalahan saat konfirmasi transfer deposit",
              "Terjadi Kesalahan"
            );
          }

          vm.disabled = true;
          vm.retry = vm.retry + 1;

          var to = 300000;

          if (vm.retry >= 3) {
            to = 864000000;
          }

          $timeout(function () {
            vm.disabled = false;
          }, to);

          var m = moment()
            .add(to / 60000, "m")
            .valueOf();
          $window.sessionStorage.setItem(
            "oresell_topup_retry_" + vm.depositData.id,
            vm.retry
          );
          store.set("oresell_next_confirm_" + vm.depositBank.toLowerCase(), m);
        }
      );
    };

    vm.batal = function () {
      $uibModalInstance.dismiss("batal");
    };

    // vm.initView = function () {
    //   var m = store.get("oresell_next_confirm");

    //   if (m) {
    //     var now = Date.now();

    //     var w = m * 1 - now;
    //     if (w > 0) {
    //       vm.disabled = true;
    //       $timeout(function () {
    //         vm.disabled = false;
    //       }, w);
    //     }
    //   }
    // };

    // vm.initView();
  }
})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('DeleteDialogController', DeleteDialogController);

  /** @ngInject */
  function DeleteDialogController($uibModalInstance, $log, APIHandling, toastr, data) {
      var vm = this;
      vm.data = data;

      vm.finish = function () {

        APIHandling.delete(vm.data.endpoint, {id: vm.data.id}).then( function () {
          toastr.success('Proses hapus berhasil', 'Sukses hapus');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.error(error);
          toastr.error('Proses hapus gagal', 'Gagal hapus');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('DeleteContactDialogController', DeleteContactDialogController);

  /** @ngInject */
  function DeleteContactDialogController($uibModalInstance,  $log, contact, toastr, data) {
      var vm = this;
      vm.contact = data;

      vm.finish = function () {

        contact.delete([vm.contact.id]).then( function () {
          toastr.success('Berhasil menghapus kontak', 'Sukses hapus');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal menghapus kontak', 'Gagal hapus');
          // $uibModalInstance.dismiss('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('ContactDetailDialogController', ContactDetailDialogController);

  /** @ngInject */
  function ContactDetailDialogController($uibModalInstance, contact, data, toastr, $log) {
      var vm = this;
      vm.cust_id = data;
      vm.noConsumen = false;

      vm.initView = function () {

        contact.get(vm.cust_id).then( function (response) {
          vm.pelanggan = response.data;

          if (response.data.extra) {
            vm.pelanggan.extra = angular.fromJson(response.data.extra);
          } else {
            vm.pelanggan.extra = {
              keterangan: null
            };
          }

        }, function (error) {
          $log.error(error);

          if (error.status === 404) {
            // toastr.error('Data pelanggan tidak ada atau sudah dihapus', 'Gagal');
            vm.noConsumen = true;
          } else {
            toastr.error('Terjadi kesalahan saat mengambil data kontak', 'Gagal');
          }
        });
      };

      vm.batal = function () {
        $uibModalInstance.dismiss('batal');
      };

      vm.initView();

  }

})();

 (function() {
  'use strict';

  angular
    .module('oresell')
    .controller('CancelTransactionDialogController', CancelTransactionDialogController);

  /** @ngInject */
  function CancelTransactionDialogController($uibModalInstance,  _, $log, transaction, toastr, data, settings) {
      var vm = this;
      vm.resume = data;

      transaction.get(vm.resume.id).then(function (response) {
        vm.order = response.data;

        vm.order.total_item = _.reduce(vm.order.produk_jual, function (sum, n) {
          return sum + n.jumlah;
        }, 0);

        vm.totalFine = vm.order.total_item * vm.settings.fine;
      });

      vm.finish = function () {

        transaction.cancel(vm.resume.id).then( function (response) {
          toastr.success('Berhasil membatalkan transaksi #' + vm.resume.id , 'Sukses');
          $uibModalInstance.close(response.data.last_balance);
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal membatalkan transaksi #' + vm.resume.id, 'Gagal');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

      vm.initView = function () {
        settings.getBase().then(function (response) {
          vm.settings = response.data.value;
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal mengambil setting denda. Coba lagi', 'Error');
        });
      };

      vm.initView();

  }

})();

'use strict';
angular.module('oresell')
.filter('topupstatus', function () {
  return function (input) {
    var status = 'Baru';

    switch (input) {
      case 'NEW':
        status = 'Baru'
        break;
      case 'TRANSFER':
        status = 'Konfirmasi Transfer';
        break;
      case 'CANCELED':
        status = 'Batal';
        break;
      case 'FINISHED':
        status = 'Selesai';
        break;
      default:
        break;
    }

    return status;
  };
});

'use strict';
angular.module('oresell')
.filter('tsdate', function ($filter) {
  return function (input, format) {
    var date = new Date(input);

    return $filter('date')(date, format);
  };
});


/*eslint angular/no-private-call: [2,{"allow":["$$rawModelValue"]}]*/

/*
 * ng-locale-number
 * based on ng-currency
 * http://alaguirre.com/
 * Version: 0.9.6 - 2016-04-04
 * License: MIT
 */

angular.module('ng-locale-number', [])
    .directive('ngLocaleNumber', ngLocaleNumber);

    function ngLocaleNumber ($filter, $locale) {
        return {
            require: 'ngModel',
            scope: {
                min: '=?min',
                max: '=?max',
                ngRequired: '=?ngRequired',
                fraction: '=?fraction'
            },
            link: function (scope, element, attrs, ngModel) {

                if (attrs.ngLocaleNumber === 'false') return;

                scope.fraction = (typeof scope.fraction !== 'undefined')?scope.fraction:2;

                function decimalRex(dChar) {
                    return RegExp("\\d|\\-|\\" + dChar, 'g');
                }

                function clearRex(dChar) {
                    return RegExp("\\-{0,1}((\\" + dChar + ")|([0-9]{1,}\\" + dChar + "?))&?[0-9]{0," + scope.fraction + "}", 'g');
                }

                function clearValue(value) {
                    value = String(value);
                    var dSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
                    var cleared = null;

                    if(value.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP) == -1 &&
                       value.indexOf('.') != -1 &&
                       scope.fraction)
                    {
                        dSeparator = '.';
                    }

                    // Replace negative pattern to minus sign (-)
                    var neg_dummy = $filter('number')("-1",  scope.fraction);
                    var neg_regexp = RegExp("[0-9."+$locale.NUMBER_FORMATS.DECIMAL_SEP+$locale.NUMBER_FORMATS.GROUP_SEP+"]+");
                    var neg_dummy_txt = neg_dummy.replace(neg_regexp.exec(neg_dummy), "");
                    var value_dummy_txt = value.replace(neg_regexp.exec(value), "");

                    // If is negative, just remove the negative sign :-P
                    if(neg_dummy_txt == value_dummy_txt) {
                        value = '' + neg_regexp.exec(value);
                    }

                    if(RegExp("^-[\\s]*$", 'g').test(value)) {
                        value = "-0";
                    }

                    if(decimalRex(dSeparator).test(value))
                    {
                        cleared = value.match(decimalRex(dSeparator))
                            .join("").match(clearRex(dSeparator));
                        cleared = cleared ? cleared[0].replace(dSeparator, ".") : null;
                    }

                    return cleared;
                }

                function reformatViewValue(){
                    var formatters = ngModel.$formatters,
                        idx = formatters.length;

                    var viewValue = ngModel.$$rawModelValue || 1;
                    while (idx--) {
                      viewValue = formatters[idx](viewValue);
                    }

                    ngModel.$setViewValue(viewValue);
                    ngModel.$render();
                }

                ngModel.$parsers.push(function (viewValue) {
                    var cVal = clearValue(viewValue);
                    //return parseFloat(cVal);
                    // Check for fast digitation (-. or .)
                    if(cVal == "." || cVal == "-.")
                    {
                        cVal = ".0";
                    }
                    return parseFloat(cVal);
                });

                element.on("blur", function () {
                    ngModel.$commitViewValue();
                    reformatViewValue();
                });

                ngModel.$formatters.unshift(function (value) {
                    return $filter('number')(value,  scope.fraction);
                });

                ngModel.$validators.min = function(cVal) {
                    if (!scope.ngRequired && isNaN(cVal)) {
                        return true;
                    }
                    if(typeof scope.min  !== 'undefined') {
                        return cVal >= parseFloat(scope.min);
                    }
                    return true;
                };

                scope.$watch('min', function () {
                    ngModel.$validate();
                });

                ngModel.$validators.max = function(cVal) {
                    if (!scope.ngRequired && isNaN(cVal)) {
                        return true;
                    }
                    if(typeof scope.max  !== 'undefined') {
                        return cVal <= parseFloat(scope.max);
                    }
                    return true;
                };

                scope.$watch('max', function () {
                    ngModel.$validate();
                });


                ngModel.$validators.fraction = function(cVal) {
                    if (!!cVal && isNaN(cVal)) {
                        return false;
                    }

                    return true;
                };

                element.on('focus',function(){
                    var viewValue = ngModel.$$rawModelValue;

                    if(isNaN(viewValue) || viewValue === '' || viewValue == null)
                    {
                        viewValue = '';
                    }
                    else
                    {
                        viewValue = parseFloat(viewValue).toFixed(scope.fraction);
                    }
                    ngModel.$setViewValue(viewValue);
                    ngModel.$render();
                });
            }
        };
    }


/**
 * Module definition and dependencies
 * Ambil dari: https://gist.github.com/adamreisnz/354364e2a58786e2be71
 */
angular.module('Api.DuplicateRequestsFilter.Decorator', [])

  /**
   * Config
   */
  .config(function ($provide) {

    /**
     * Decorator for the $http service
     */
    $provide.decorator('$http', function ($delegate, $q) {

      /**
       * Pending requests and local $http var for natural reference
       */
      var pendingRequests = {};
      var $http = $delegate;

      /**
       * Hash generator
       */
      function hash(str) {
        var h = 0;
        var strlen = str.length;
        if (strlen === 0) {
          return h;
        }
        for (var i = 0, n; i < strlen; ++i) {
          n = str.charCodeAt(i);
          h = ((h << 5) - h) + n;
          h = h & h;
        }
        return h >>> 0;
      }

      /**
       * Helper to generate a unique identifier for a request
       */
      function getRequestIdentifier(config) {
        var str = config.method + config.url;
        if (config.params && angular.isObject(config.params)) {
          str += angular.toJson(config.params);
        }
        if (config.data && angular.isObject(config.data)) {
          str += angular.toJson(config.data);
        }
        return hash(str);
      }

      /**
       * Modified $http service
       */
      var $duplicateRequestsFilter = function (config) {

        //Ignore for this request?
        if (config.ignoreDuplicateRequest) {
          return $http(config);
        }

        //Get unique request identifier
        var identifier = getRequestIdentifier(config);

        //Check if such a request is pending already
        if (pendingRequests[identifier]) {
          if (config.rejectDuplicateRequest) {
            return $q.reject({
              data: '',
              headers: {},
              status: config.rejectDuplicateStatusCode || 400,
              config: config
            });
          }
          return pendingRequests[identifier];
        }

        //Create promise using $http and make sure it's reset when resolved
        pendingRequests[identifier] = $http(config).finally(function () {
          delete pendingRequests[identifier];
        });

        //Return promise
        return pendingRequests[identifier];
      };

      //Map rest of methods
      Object.keys($http).filter(function (key) {
        return (angular.isFunction($http[key]));
      }).forEach(function (key) {
        $duplicateRequestsFilter[key] = $http[key];
      });

      //Map defaults
      $duplicateRequestsFilter.defaults = $http.defaults;

      //Return it
      return $duplicateRequestsFilter;
    });
  });

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainTransactionHistoryController', MainTransactionHistoryController);

  /** @ngInject */
  function MainTransactionHistoryController($log, transaction, moment, _, $uibModal, toastr) {

    var vm = this;
    vm.transactionList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.shownPage = 1;

    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.filter = {
      page: 1,
      per_page: 10,
      by_id: null,
      by_pembeli: null,
      tgl_min: null,
      tgl_max: null,
      tgl_opt: 4, /* Di antara tgl_min dan tgl_max */
      order_by: 'by_tgl',
      sorting: 'desc'
    };

    vm.showDetail = function (id) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/components/modals/TransactionDetail/TransactionDetailDialog.html',
        controller: 'TransactionDetailDialogController as vm',
        resolve: {
          data: function () {
            return id;
          }
        }
      });
    };

    vm.inProcess = false;

    vm.showCustomerDetail = function (cust_id) {
      $uibModal.open({
        animation: true,

        templateUrl: 'app/components/modals/ContactDetail/ContactDetailDialog.html',
        controller: 'ContactDetailDialogController as vm',
        resolve: {
          data: function () {
            return cust_id;
          }
        }
      });
    };

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }

      transaction.list(filter).then(function (response) {
        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.transactionList = response.data.data;
        vm.shownPage = filter.page;

        _.each(vm.transactionList, function (n) {
          n.lain_lain = angular.fromJson(n.lain_lain);
        });
      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data transaksi', 'Terjadi Kesalahan');
        }
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainPendingController', MainPendingController);

  /** @ngInject */
  function MainPendingController($uibModal, $scope, $log, transaction, moment, toastr, _) {

    var vm = this;
    vm.transactionList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.shownPage = 1;

    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.filter = {
      page: 1,
      per_page: 10,
      by_pembeli: null,
      by_id: null,
      tgl_min: null,
      tgl_max: null,
      mode: 2, /*  mode 0 = semua, 1 = dibayar, 2 = pending */
      tgl_opt: 4 /* Di antara tgl_min dan tgl_max */
    };

    vm.showDetail = function (id) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/components/modals/TransactionDetail/TransactionDetailDialog.html',
        controller: 'TransactionDetailDialogController as vm',
        resolve: {
          data: function () {
            return id;
          }
        }
      });
    };

    vm.processOrder = function (order) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/ProcessOrder/ProcessOrderDialog.html',
        controller: 'ProcessOrderDialogController as vm',
        size: 'lg',
        keyboard: false,
        backdrop: 'static',
        scope: $scope,
        resolve: {
          order: function () {
            return order;
          }
        }
      }).result.then(function (response) {
        vm.user.data.name = response.data.name;
      }, function (error) {
        $log.info(error);
      });

    };

    vm.showCustomerDetail = function (cust_id) {
      $uibModal.open({
        animation: true,

        templateUrl: 'app/components/modals/ContactDetail/ContactDetailDialog.html',
        controller: 'ContactDetailDialogController as vm',
        resolve: {
          data: function () {
            return cust_id;
          }
        }
      });
    };

    vm.cancelOrder = function (transaction) {
      $uibModal.open({
        animation: true,

        templateUrl: 'app/components/modals/CancelTransaction/CancelTransactionDialog.html',
        controller: 'CancelTransactionDialogController as vm',
        resolve: {
          data: function () {
            return transaction;
          }
        }
      }).result.then(function (balance) {
        vm.initView(vm.filter.page);
        $scope.$emit('CHANGEBALANCE', balance);
      });
    };

    $scope.$on('REFRESHLIST', function () {
      vm.initView(vm.filter.page);
    });

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }

      transaction.list( filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.transactionList = response.data.data;
        vm.shownPage = filter.page;
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainOrderClosedController', MainOrderClosedController);

  /** @ngInject */
  function MainOrderClosedController() {


  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainOrderController', MainOrderController);

  /** @ngInject */
  function MainOrderController(_, product, toastr, $log, $scope) {
    var vm = this;

    vm.productList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.shownPage = 1;

    /** Data user ada di scope main. Tidak perlu ambil lagi via user service */
    vm.user = $scope.main.user;

    vm.filter = {
      by_sku: null,
      search: null,
      only_with_sku: 1,
      by_size: null,
      per_page: 10,
      woo_only: 0,
      only_with_stok: '1'
    };

    vm.changePage = function (page) {
      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }
    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.addToCart = function (item) {

      if ((item.weight * 1000) < 1) {
        toastr.error(item.nama + ' belum memiliki data berat. Harap kontak CS agar diperbaiki', 'Gagal');
      } else {
        // if (
        //   $scope.main.totalOrder + item.harga_diskon <=
        //   $scope.main.user.balance
        // ) {
        //   if (item.jumlah > 0) {
        //     item.jumlah = item.jumlah - 1;
        //     $scope.$emit('ADDITEM', item);
        //   }
        // } else {
        //   toastr.error('Saldo tidak cukup', 'Gagal');
        // }

        if (item.jumlah > 0) {
          item.jumlah = item.jumlah - 1;
          $scope.$emit('ADDITEM', item);
        }
      }

    };

    $scope.$on('RESTROREITEM', function (event, item) {
      var product = _.find(vm.productList.data, function (o) { return o.sku === item.sku; });

      if ((product.jumlah + item.jumlah) <= product.current_stok) {
        product.jumlah = product.jumlah + item.jumlah;
      }

    });

    $scope.$on('CHANGEITEMLISTQTY', function (event, item) {
      var product = _.find(vm.productList.data, function (o) { return o.sku === item.sku; });

      product.jumlah = product.current_stok - item.jumlah;

    });

    vm.initView = function (page) {

      vm.filter.page = page;
      // var orderItem = _.map($scope.main.order, 'sku');

      /* Pastikan search ada isinya atay null, kalau tidak, akan memperoleh hasil query yang salah */
      vm.filter.search = vm.filter.search || null;

      var filter = _.cloneDeep(vm.filter);

      product.list(filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        /* Filter data detail produk, ubah yang sebelumnya cuma data teks, menjadi object */

        /*
          Tambahkan field harga_diskon, yaitu harga yg sudah dikurangi diskon dg
          besar diskon tergantung level user.
        */
        _.each(response.data.data, function (n) {

          /** Pastikan kolom - kolom angka menjadi angka */
          n.harga = n.harga * 1;
          n.jumlah = n.jumlah * 1;
          n.sale_price = n.sale_price ? (n.sale_price * 1) : null;
          n.weight = n.weight * 1;
          n.reseller_discount_persen_sku = n.reseller_discount_persen_sku * 1;
          n.reseller_discount_persen_category = n.reseller_discount_persen_category * 1;

          /** Harga diskon */
          /** Tahap 1: Tentukan persentase diskon dari diskon level user */
          /** Tahap 2: Cek apakah ada diskon dari SKU dan Kategori. Diskon SKU lebih utama dari kategori */
          /** Tahap 3: Cek apakah diskon diskon level lebih besar dari diskon SKU/Category. */
          /**          Jika lebih besar, maka gunakan diskon SKU/Kategori. Jika tidak, maka gunakan diskon level  */

          var discount = (vm.user.discount * 1);

          if (n.reseller_discount_persen_sku > 0) {
            discount = (discount > n.reseller_discount_persen_sku) ? n.reseller_discount_persen_sku : discount;
          } else if (n.reseller_discount_persen_category > 0) {
            discount = (discount > n.reseller_discount_persen_category) ? n.reseller_discount_persen_category : discount;
          }

          n.harga_diskon = n.harga - (( discount / 100) * n.harga);

          /** Jika ada sale, dan harga diskon lebih murah dari harga sale, maka gunakan harga diskon. Jika sebaliknya; gunakan sale_price */
          if (n.on_sale) {
            n.harga_diskon = n.harga_diskon < n.sale_price ? n.harga_diskon : n.sale_price;
          }

          n.detail = angular.fromJson(n.detail);
          n.current_stok = n.jumlah;

          var inOrder = _.find($scope.main.order, function (o) {
            return o.sku === n.sku;
          });

          if (inOrder) {
            n.jumlah = n.jumlah - inOrder.jumlah;
          }

          n.family = _.find(n.detail.attributes, function (o) {
            return o.name === 'FAMILY';
          });
        });

        vm.productList = response.data;
        vm.shownPage = filter.page;

      });
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainInsightController', MainInsightController);

  /** @ngInject */
  function MainInsightController(_, $window, transaction) {
    var vm = this;

    vm.filter = {
      range: '2w'
    };

    vm.options = {
      chart: {
        type: 'pieChart',
        height: 500,
        x: function (d) {
          return d.nama;
        },
        y: function (d) { return d.jumlah; },
        showLabels: true,
        duration: 500,
        labelThreshold: 0.01,
        labelSunbeamLayout: true,
        legend: {
          margin: {
            top: 5,
            right: 15,
            bottom: 5,
            left: 0
          }
        },
        showLegend: true,
        legendPosition: 'right',
        pie: {
          dispatch: {
            elementClick: function (info) {
              $window.open(info.data.permalink, '_blank');
            }
          }
        },
        tooltip: {
          enabled: false
        }
      },
      title: {
        enable: true,
        text: '10 Produk Terlaris'
      }
    };

    vm.initView = function () {
      transaction.getBestSeller({
        range: vm.filter.range
      }).then(function (response) {
        vm.data = response.data;
      });
    };

    vm.initView();

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainInboxController', MainInboxController);

  /** @ngInject */
  function MainInboxController(inbox, $log, toastr, $scope, _) {

    var vm = this;
    vm.inboxList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.inProcess = false;

    vm.filter = {
      page: 1,
      per_page: 10,
      search: null,
      by_hp: null,
      by_status: 1
    };

    vm.openMessage = function (item) {
      if (item.status === 0) {
        item.status = 1;
        inbox.save(item).then(function () {
          $scope.$emit('UPDATEUNREAD');
        }, function (error) {
          $log.error(error);
          toastr.error(error.data.message, 'Gagal update pesan');
        });
      }
    };

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      inbox.list(filter).then(function (response) {

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (!response.data.next_page_url) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.inboxList = response.data.data;

      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data inbox', 'Terjadi Kesalahan');
        }
      });
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainDepositTicketController', MainDepositTicketController);

  /** @ngInject */
  function MainDepositTicketController(topup, $log, $uibModal, toastr, moment, _, Papa, saveAs) {

    var vm = this;
    vm.ticketList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.shownPage = 1;
    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = true;
    };

    vm.today = new Date();
    vm.minDate = new Date(moment(vm.today).subtract(45, 'days'));

    vm.filter = {
      page: 1,
      per_page: 10,
      tglAwal: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tglAkhir: vm.today,
      totalTransfer: null,
      accountNumber: null,
      bank: null,
      status: ''
    };

    vm.collapse = true;

    vm.initView = function (page, download) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tglAwal = moment(filter.tglAwal).format('YYYY-MM-DD');
      filter.tglAkhir = moment(filter.tglAkhir).format('YYYY-MM-DD');

      if (download) {
        filter.per_page = 1000;
      }

      topup.list(filter).then(function (response) {
        if (download) {

          var data = [];

          _.each(response.data.deposit, function (n) {
            data.push(_.omit(n, ['id', 'owner', 'created_at', 'updated_at', 'updated_by', 'bank']));
          }) ;

          var csv = Papa.unparse(data, {
            worker: false,
            skipEmptyLines: true
          });

          var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });

          saveAs(blob, 'MutasiDeposit.csv');
        } else {
          if (page === 1) {
            vm.maxPage = (response.data.last_page * 1) || 1;
          }

          /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
          if (page === vm.maxPage) {
            vm.isLastPage = true;
          } else {
            vm.isLastPage = false;
          }

          vm.ticketList = response.data;
          vm.shownPage = filter.page;
        }

      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data deposit', 'Terjadi Kesalahan');
        }
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.createTicket = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/DepositTicket/DepositTicket.html',
        controller: 'DepositTicketController as vm',
        size: 'md',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          data: function () {
            return '';
          }
        }
      }).result.then(function (response) {
        $log.info(response);
        vm.initView(1);
      }, function (error) {
        $log.error(error);
        vm.initView(1);
      });
    };

    vm.showTicket = function (ticket) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/ViewDepositTicket/ViewDepositTicket.html',
        controller: 'ViewDepositTicketController as vm',
        size: 'md',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          data: function () {
            return ticket;
          }
        }
      }).result.then(function (response) {
        $log.info(response);
        vm.initView(1);
      }, function (error) {
        $log.error(error);
        vm.initView(1);
      });
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainDepositController', MainDepositController);

  /** @ngInject */
  function MainDepositController(deposit, $log, toastr, moment, _, Papa, saveAs) {

    var vm = this;
    vm.depositList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.shownPage = 1;
    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = true;
    };

    vm.today = new Date();
    vm.minDate = new Date(moment(vm.today).subtract(45, 'days'));

    vm.filter = {
      page: 1,
      per_page: 10,
      tglAwal: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tglAkhir: vm.today
    };

    vm.initView = function (page, download) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tglAwal = moment(filter.tglAwal).format('YYYY-MM-DD');
      filter.tglAkhir = moment(filter.tglAkhir).format('YYYY-MM-DD');

      if (download) {
        filter.per_page = 1000;
      }

      deposit.list(filter).then(function (response) {
        if (download) {

          var data = [];

          _.each(response.data.deposit, function (n) {
            data.push(_.omit(n, ['id', 'owner', 'created_at', 'updated_at', 'updated_by', 'bank']));
          }) ;

          var csv = Papa.unparse(data, {
            worker: false,
            skipEmptyLines: true
          });

          var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });

          saveAs(blob, 'MutasiDeposit.csv');
        } else {
          if (page === 1) {
            vm.maxPage = (response.data.max_page * 1) || 1;
          }

          /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
          if (page === vm.maxPage) {
            vm.isLastPage = true;
          } else {
            vm.isLastPage = false;
          }

          vm.depositList = response.data;
          vm.shownPage = filter.page;
        }

      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data deposit', 'Terjadi Kesalahan');
        }
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainContactController', MainContactController);

  /** @ngInject */
  function MainContactController(contact, $log, toastr, $uibModal, _) {

    var vm = this;
    vm.contactList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.inProcess = false;

    vm.check = {
      item: [],
      mainItem: false,
      checkAll: function () {
        _.each(vm.contactList.contact, function (o, n) {
          vm.check.item[n].status = vm.check.mainItem;
        });
      }
    };

    vm.filter = {
      page: 1,
      per_page: 10,
      search: null,
      by_hp: null,
      by_status: 1
    };

    vm.editContact = function (contact) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/components/modals/EditContact/EditContactDialog.html',
        controller: 'EditContactDialogController as vm',
        resolve: {
          data: function () {
            return contact;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.deleteContact = function (contact) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/DeleteContact/DeleteContactDialog.html',
        controller: 'DeleteContactDialogController as vm',
        resolve: {
          data: function () {
            return contact;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.importContact = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/ImportContact/ImportContactDialog.html',
        controller: 'ImportContactController as vm'
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.deleteSelectedContacts = function () {

      var list_id = _(vm.check.item).filter(function (n) { return n.status === true; }).map(function (n) { return n.id; }).value();

      if (!_.isEmpty(list_id)) {

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modals/MassDeleteContact/MassDeleteContactDialog.html',
          controller: 'MassDeleteContactDialogController as vm',
          resolve: {
            data: function () {
              return list_id;
            }
          }
        }).result.then(function () {
          vm.initView(vm.filter.page);
        });


        // contact.delete(list_id).then(function () {
        //   vm.initView(vm.filter.page);
        //   toastr.success('Berhasil hapus data kontak', 'Hapus berhasil');
        // }, function (error) {
        //   $log.error(error);
        //   toastr.error('Gagal hapus kontak. Kode error: ' + error.status, 'Gagal hapus');
        // });
      }

    };

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      vm.check.mainItem = false;

      contact.list(filter).then(function (response) {
        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.contactList = response.data;

        _.each(vm.contactList.contact, function (o, n) {
          vm.check.item[n] = {
            status: false,
            id: o.id
          };
        });
      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data kontak', 'Terjadi Kesalahan');
        }
      });
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController($log, AUTHandling, INFOHandling, BUILD, CAPCHA_KEY, vcRecaptchaService, $state, $stateParams, toastr) {
    var vm = this;
    vm.inProcess = false;

    vm.capchaKey = CAPCHA_KEY;

    vm.widgetId = null;
    vm.user = {
      password: null,
      confirm_password: null,
      email: null,
      recapcha: null
    };

    vm.capcha = {
      setId: function (widgetId) {
        vm.widgetId = widgetId;
      },
      reload: function () {
        vcRecaptchaService.reload(vm.widgetId);
        vm.user.recapcha = null;
      },
      success: function (response) {
        vm.user.recapcha = response;
        vm.resetPassword();
      }
    };

    vm.prepareResetPassword = function () {
      vcRecaptchaService.execute(vm.widgetId);
    };

    vm.resetPassword = function () {

      vm.inProcess = true;

      AUTHandling.resetPassword(vm.user).then(function () {
        vm.inProcess = false;

        toastr.success('Password berhasil diubah. Silahkan login dengan password baru', 'Sukses');
        $state.go('login');
      }, function (error) {
        $log.error(error);
        vm.inProcess = false;
        var msg = '';

        if (error.status === 503) {
          msg = 'Server sedang sibuk. Silahkan coba beberapa saat lagi';
        } else if (error.status === 401) {
          msg = 'Validasi gagal. Minta ulang url baru untuk reset password';
        } else if (error.status === 428) {
          msg = 'Captcha salah';
        } else if (error.status === 422) {
          msg = 'Captcha belum diisi';
        } else if (error.status === 404) {
          msg = 'User tidak ditemukan';
        } else {
          msg = 'Server error';
        }

        vm.capcha.reload();

        toastr.error(msg, 'Gagal');
      });

    };

    vm.init = function () {
      try {
        var data = atob($stateParams.token);
        data = angular.fromJson(data);

        if (data.email) {
          vm.user.email = data.email;
          vm.user.token = data.token;
        } else {
          $state.go('login');
        }
      } catch (error) {
        $log.error(error);
        $state.go('login');
      }

    };

    vm.init();

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('RegistrasiTutupController', RegistrasiTutupController);

  /** @ngInject */
  function RegistrasiTutupController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('RegistrasiSuksesController', RegistrasiSuksesController);

  /** @ngInject */
  function RegistrasiSuksesController($stateParams) {
    var vm = this;

    var data = atob($stateParams.info);
    var dataA = angular.fromJson(data);

    vm.info = dataA;

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('RegistrasiGagalController', RegistrasiGagalController);

  /** @ngInject */
  function RegistrasiGagalController($stateParams) {
    var vm = this;

    var data = atob($stateParams.info);
    var dataA = angular.fromJson(data);

    vm.info = dataA;

    if ((vm.info.status * 1) === 503) {
      vm.info.msg = 'server sedang sibuk. Coba beberapa saat lagi';
    } else if ((vm.info.status * 1) === 409) {
      vm.info.msg = 'Email <strong><a href="">' + vm.info.email + '</a></strong> sudah terdaftar. Gunakan email lain';
    } else if ((vm.info.status * 1) === 428) {
      vm.info.msg = 'captcha salah. Coba lagi';
    } else {
      vm.info.msg = 'server error. Coba beberapa saat lagi';
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('RegistrasiController', RegistrasiController);

  /** @ngInject */
  function RegistrasiController($log, user, $state, $location) {
    var vm = this;
    vm.inProcess = false;
    vm.gclid = $location.search()['gclid'];

    vm.pattern = {
      number: /^(([\+][0-9]+)|([0-9]+))$/
    };

    vm.doRegistration = function () {
      vm.inProcess = true;

      if (vm.gclid) {
        vm.user.gclid = vm.gclid;
      }

      user.register(vm.user).then(function (response) {
        vm.inProcess = false;

        if (response.status === 201) {
          var info = btoa(angular.toJson({ email: vm.user.email}));
          $state.go('registrasi-sukses', {info: info});
        }

      }, function (error) {
        $log.error(error);
        vm.inProcess = false;

          var info = btoa(angular.toJson({ email: vm.user.email, status: error.status }));
          $state.go('registrasi-gagal',  {info: info});
      });

    };


    vm.init = function () {
      // INFOHandling.getVersion().then(function (response) {
      //   $log.info(response);
      // });

      // user.checkToken().then(function () {
      //   $state.go('main.transaksi');
      // }, function () {
      //   $log.info('No valid token provided. Stay at login page');
      // });
    };

    vm.init();

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($state, $uibModal, TODAY, $rootScope, $log, AUTHandling, user, inbox, $scope, $timeout, store, _) {
    var vm = this;

    vm.isCollapsed = false;
    vm.sidebarCollapse = false;
    vm.activeState = $rootScope.activeState;
    vm.isConnected = false;
    vm.user = null;
    vm.isCheckBalance = false;
    vm.totalInbox = 0;

    vm.order = [];

    vm.calculateTotalItem = function () {
      vm.totalItem = _.reduce(vm.order, function (sum, n) {
        return sum + n.jumlah;
      }, 0);
    };

    vm.calculateTotalOrder = function () {
      vm.totalOrder = _.reduce(vm.order, function (sum, n) {
        return sum + (n.harga_diskon * n.jumlah);
      }, 0);
    };

    vm.notification = [];

    vm.copyright = {
      company: 'Ethica Collection',
      year: TODAY.getFullYear(),
      url: 'https://ethica-collection.com',
      message: 'Sistem Reseller Ethica Collection'
    };

    vm.changeCollapse = function (state) {
      if (state.child) {
        vm.isCollapsed = !vm.isCollapsed;
      }
    };

    vm.toggleSidebar = function () {
      vm.sidebarCollapse = !vm.sidebarCollapse;
    };

    vm.menuItem = [

      {
        text: 'Insight',
        sref: 'main.insight',
        icon: 'fa-dashboard'
      },

      {
        text: 'Order',
        sref: 'main.order',
        icon: 'fa-shopping-bag'
      },

      {
        text: 'Transaksi Pending',
        sref: 'main.pending',
        icon: 'fa-save'
      },

      {
        text: 'Riwayat Transaksi',
        sref: 'main.transaction-history',
        icon: 'fa-history'
      },

      {
        text: 'Topup Deposit',
        sref: 'main.deposit-ticket',
        icon: 'fa-ticket'
      },

      {
        text: 'Mutasi Deposit',
        sref: 'main.deposit',
        icon: 'fa-credit-card'
      },

      {
        text: 'Kontak',
        sref: 'main.contact',
        icon: 'fa-address-card-o'
      }

    ];

    // if (vm.user.type === 'ADMIN') {
    //   vm.menuItem.push({
    //     text: 'User',
    //     sref: 'main.user',
    //     icon: 'fa-users'
    //   });
    // }

    vm.isActive = function (state) {

      if (($state.current.name === state.sref) && (!state.child)) {
        return true;
      } else {
        return false;
      }

    };

    vm.logout = function () {
      AUTHandling.logout();
    };

    vm.userProfile = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/UserProfile/UserProfile.html',
        controller: 'UserProfileController as vm',
        size: 'lg',
        keyboard: false,
        backdrop: 'static',
        resolve: {
          data: function () {
            return vm.user;
          }
        }
      }).result.then(function (response) {
        vm.user = response;
      }, function (error) {
        $log.error(error);
      });
    };

    $scope.$on('ADDITEM', function (event, item) {
      var orderedItem = _.cloneDeep(item);

      orderedItem.discount_nominal = 0;
      orderedItem.discount_persen = (vm.user.discount * 1);
      orderedItem.discount_total = ((vm.user.discount * 1)/100) * (orderedItem.harga * 1);

      /** Jika ada sale */
      if (orderedItem.sale_price > 0) {
        var discount_sale = orderedItem.harga - orderedItem.sale_price;

        if (discount_sale > orderedItem.discount_total) {
          orderedItem.discount_persen = 0;
          orderedItem.discount_nominal = discount_sale;
          orderedItem.discount_total = discount_sale;
        }
      }

      orderedItem.harga_jual = orderedItem.harga;
      orderedItem.produk_id = orderedItem.id;
      orderedItem.jumlah = 1;

      var a = _.find(vm.order, { id: orderedItem.id });

      if (a) {
        a.jumlah = a.jumlah + 1;
      } else {
        vm.order.push(orderedItem);
      }

      orderedItem.total = orderedItem.jumlah * orderedItem.harga_jual;

      // vm.totalItem = _.reduce(vm.order, function (sum, n) {
      //   return sum + n.jumlah;
      // }, 0);

      vm.calculateTotalItem();
      vm.calculateTotalOrder();

      // vm.user.balance = vm.user.balance - orderedItem.harga_diskon;
      // store.set('user', vm.user);

      store.set('oresell_order_' + vm.user.id , vm.order);
    });

    $scope.$on('FINISHORDER', function (event, data) {
      store.remove('oresell_order_' + vm.user.id);
      vm.user.balance = data.last_balance;
      store.set('oresell_user', vm.user);
      vm.order = [];
      vm.calculateTotalItem();
      vm.calculateTotalOrder();
    });

    $scope.$on('FINISHPENDING', function (event, data) {
      vm.user.balance = data.last_balance;
      store.set('oresell_user', vm.user);
      $scope.$broadcast('REFRESHLIST');
    });

    $scope.$on('REMOVEITEM', function (event, data) {
      vm.order.splice(data.index, 1);
      store.set('oresell_order_' + vm.user.id , vm.order);
      vm.calculateTotalItem();
      vm.calculateTotalOrder();

      $scope.$broadcast('RESTROREITEM', data.item);
    });

    $scope.$on('CHANGEQTY', function (event, data) {

      var item = _.find(vm.order, function (n) {
        return n.sku === data.sku;
      });
      item.jumlah = data.jumlah;
      store.set('oresell_order_' + vm.user.id , vm.order);

      vm.calculateTotalItem();
      vm.calculateTotalOrder();

      $scope.$broadcast('CHANGEITEMLISTQTY', data);
    });

    $scope.$on('CLEARALLITEM', function () {
      _.each(vm.order, function (n) {
        $scope.$broadcast('RESTROREITEM', n);
      });

      vm.order = [];
      vm.calculateTotalItem();
      vm.calculateTotalOrder();
      store.set('oresell_order_' + vm.user.id , vm.order);
    });

    $scope.$on('CHANGEBALANCE', function (event, balance) {
      vm.user.balance = balance;
      store.set('oresell_user', vm.user);
    });

    $scope.$on('UPDATEUNREAD', function () {
      vm.totalInbox = vm.totalInbox > 0 ? vm.totalInbox - 1 : 0;
    });

    vm.processOrder = function () {
      if (vm.order.length > 0) {
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modals/ProcessOrder/ProcessOrderDialog.html',
          controller: 'ProcessOrderDialogController as vm',
          size: 'lg',
          keyboard: false,
          backdrop: 'static',
          scope: $scope,
          resolve: {
            order: function () {
              return { produk_jual: vm.order };
            }
          }
        }).result.then(function (response) {
          vm.user.data.name = response.data.name;
        }, function (error) {
          $log.info(error);
        });
      }

    };

    vm.refreshBalance = function () {
      vm.isCheckBalance = true;
      user.checkBalance().then(function (response) {
        vm.user.balance = response.data.balance;
        store.set('oresell_user', vm.user);
      }, function (error) {
        $log.error(error);
      }).finally(function () {
        vm.isCheckBalance = false;
      });
    };

    vm.checkInbox = function () {
      inbox.unread().then(function (response) {
        vm.totalInbox = response.data.unreadMessage;
        $timeout(function() {
          vm.checkInbox();
        }, 300000);
      });
    };

    vm.updateBalance = function () {
      user.checkBalance().then(function (response) {
        vm.user.balance = response.data.balance;
        store.set('oresell_user', vm.user);
      }, function (error) {
        $log.error(error);
      }).finally(function () {
        $timeout(function() {
          vm.updateBalance();
        }, 300000);
      });
    };

    vm.init = function () {

      vm.user = user.getData();

      if (vm.user) {
        vm.order = store.get("oresell_order_" + vm.user.id) || [];


        // if (vm.user.email === 'testersilver@oresell.com') {
        //   vm.menuItem.splice(4, 0, {
        //     text: 'Topup Deposit',
        //     sref: 'main.deposit-ticket',
        //     icon: 'fa-ticket'
        //   });
        // }

      } else {
        $state.go('login');
      }


      vm.calculateTotalItem();
      vm.calculateTotalOrder();
      vm.updateBalance();

      if (!vm.user.contact_id) {
        vm.userProfile();
      }

      vm.checkInbox();
    };

    vm.init();

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($log, AUTHandling, INFOHandling, BUILD, CAPCHA_KEY, vcRecaptchaService, $state, $stateParams, toastr) {
    var vm = this;
    vm.inProcess = false;

    vm.capchaKey = CAPCHA_KEY;

    vm.widgetId = null;

    vm.capcha = {
      setId: function (widgetId) {
        vm.widgetId = widgetId;
      },
      reload: function () {
        vcRecaptchaService.reload(vm.widgetId);
        vm.user.recapcha = null;
      },
      success: function (response) {
        vm.user.recapcha = response;
        vm.doLogin();
      }
    };

    vm.prepareLogin = function () {
      vcRecaptchaService.execute(vm.widgetId);
    };

    vm.doLogin = function () {

      vm.inProcess = true;

      AUTHandling.login(vm.user.uname, vm.user.password, vm.user.recapcha).then(function (response) {
        vm.inProcess = false;

        if (response.status === 200) {
          $state.go('main.order');
        }

      }, function (error) {
        $log.error(error);
        vm.inProcess = false;
        var msg = '';

        if (error.status === 503) {
          msg = 'Server sedang sibuk. Silahkan coba beberapa saat lagi';
        } else if (error.status === 401) {
          msg = 'Email atau password salah';
        } else if (error.status === 412) {
          msg = 'User belum aktif / nonaktif. Silahkan hubungi CS';
        } else if (error.status === 428) {
          msg = 'Captcha salah';
        } else if (error.status === 422) {
          msg = 'Captcha belum diisi';
        } else {
          msg = 'Server error';
        }

        vm.capcha.reload();

        toastr.error(msg, 'Login Gagal');
      });

    };


    vm.init = function () {
      $log.info('Client Build: ' + BUILD);
      INFOHandling.getVersion().then(function (response) {
        $log.info('Server Build: ' + response.server_build);
      });
    };

    vm.init();

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController($log, AUTHandling, INFOHandling, BUILD, CAPCHA_KEY, vcRecaptchaService, $state, $stateParams, toastr) {
    var vm = this;
    vm.inProcess = false;
    vm.finishRequest = false;

    vm.capchaKey = CAPCHA_KEY;

    vm.widgetId = null;

    vm.user = {
      email: null,
      recapcha: null
    };

    vm.capcha = {
      setId: function (widgetId) {
        vm.widgetId = widgetId;
      },
      reload: function () {
        vcRecaptchaService.reload(vm.widgetId);
        vm.user.recapcha = null;
      },
      success: function (response) {
        vm.user.recapcha = response;
        vm.requestResetPassword();
      }
    };

    vm.prepareRequestResetPassword = function () {
      vcRecaptchaService.execute(vm.widgetId);
    };

    vm.requestResetPassword = function () {

      vm.inProcess = true;

      AUTHandling.requestResetPassword(vm.user).then(function () {
        vm.inProcess = false;

        toastr.success('Reset password berhasil', 'Berhasil');

        vm.user.recapcha = null;

        vm.finishRequest = true;

        // if (response.status === 200) {
        //   $state.go('main.order');
        // }

      }, function (error) {
        $log.error(error);
        vm.inProcess = false;
        var msg = '';

        if (error.status === 503) {
          msg = 'Server sedang sibuk. Silahkan coba beberapa saat lagi';
        } else if (error.status === 401) {
          msg = 'Email atau password salah';
        } else if (error.status === 428) {
          msg = 'Captcha salah';
        } else if (error.status === 422) {
          msg = 'Captcha belum diisi';
        } else if (error.status === 404) {
          msg = 'User tidak ditemukan';
        } else {
          msg = 'Server error';
        }

        vm.capcha.reload();

        toastr.error(msg, 'Gagal');
      });

    };


    vm.init = function () {
      $log.info('Client Build: ' + BUILD);
      INFOHandling.getVersion().then(function (response) {
        $log.info('Server Build: ' + response.server_build);
      });
    };

    vm.init();

  }
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $window, $location) {

    var deregisterationCallback = $rootScope.$on('$stateChangeSuccess', function(event, toState){
      $rootScope.activeState = toState;

      $window.dataLayer.push({
        event: 'pageView',
        action: $location.path()
      });
    });

    $rootScope.$on('$destroy', deregisterationCallback);
  }

})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        abstrac: true,
        defaultSubstate: 'main.order',
        // onEnter: function(AUTHandling){
        //   AUTHandling.checkToken();
        // }
      })

      .state('main.insight', {
        url: '/insight',
        templateUrl: 'app/main/main.insight/main.insight.html',
        controller: 'MainInsightController',
        controllerAs: 'vm',
        data: {
          title: 'Insight',
          icon: 'fa-dashboard',
          style: 'bg-header-insight'
        },
      })

      .state('main.order', {
        url: '/order',
        templateUrl: 'app/main/main.order/main.order.html',
        controller: 'MainOrderController',
        controllerAs: 'vm',
        data: {
          title: 'Order',
          icon: 'fa-shopping-bag',
          style: 'bg-header-order'
        },
      })

      // .state('main.order', {
      //   url: '/order',
      //   templateUrl: 'app/main/main.order-closed/main.order-closed.html',
      //   controller: 'MainOrderClosedController',
      //   controllerAs: 'vm',
      //   data: {
      //     title: 'Order Closed',
      //     icon: 'fa-shopping-bag'
      //   }
      // })

      .state('main.pending', {
        url: '/pending',
        templateUrl: 'app/main/main.pending/main.pending.html',
        controller: 'MainPendingController',
        controllerAs: 'vm',
        data: {
          title: 'Transaksi Pending',
          icon: 'fa-save',
          style: 'bg-header-pending'
        },
      })

      .state('main.transaction-history', {
        url: '/transaction-history',
        templateUrl:
          'app/main/main.transaction-history/main.transaction-history.html',
        controller: 'MainTransactionHistoryController',
        controllerAs: 'vm',
        data: {
          title: 'Riwayat Transaksi',
          icon: 'fa-history',
          style: 'bg-header-history'
        },
      })

      .state('main.deposit-ticket', {
        url: '/deposit-ticket',
        templateUrl: 'app/main/main.deposit-ticket/main.deposit-ticket.html',
        controller: 'MainDepositTicketController',
        controllerAs: 'vm',
        data: {
          title: 'Topup Deposit',
          icon: 'fa-ticket',
          style: 'bg-header-topup'
        },
      })

      .state('main.deposit', {
        url: '/deposit',
        templateUrl: 'app/main/main.deposit/main.deposit.html',
        controller: 'MainDepositController',
        controllerAs: 'vm',
        data: {
          title: 'Mutasi Deposit',
          icon: 'fa-credit-card',
          style: 'bg-header-deposit'
        },
      })

      .state('main.contact', {
        url: '/contact',
        templateUrl: 'app/main/main.contact/main.contact.html',
        controller: 'MainContactController',
        controllerAs: 'vm',
        data: {
          title: 'Kontak',
          icon: 'fa-address-card-o',
          style: 'bg-header-contact'
        },
      })

      .state('main.inbox', {
        url: '/inbox',
        templateUrl: 'app/main/main.inbox/main.inbox.html',
        controller: 'MainInboxController',
        controllerAs: 'vm',
        data: {
          title: 'Inbox',
          icon: 'fa-envelope-o',
          style: 'bg-header-inbox'
        },
      })

      .state('login', {
        url: '/',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        data: {
          title: 'Login',
          icon: 'fa-sign-in',
        },
      })

      // .state('registrasi', {
      //   url: '/registrasi',
      //   templateUrl: 'app/registrasi/registrasi.html',
      //   controller: 'RegistrasiController',
      //   controllerAs: 'vm',
      //   data: {
      //     title: 'Registrasi',
      //     icon: 'fa-sign-in',
      //   },
      // })

      .state('registrasi', {
        url: '/registrasi',
        templateUrl: 'app/registrasi-tutup/registrasi-tutup.html',
        controller: 'RegistrasiTutupController',
        controllerAs: 'vm',
        data: {
          title: 'Registrasi Tutup',
          icon: 'fa-sign-in',
        },
      })

      .state('registrasi-sukses', {
        url: '/registrasi-sukses/:info',
        templateUrl: 'app/registrasi-sukses/registrasi-sukses.html',
        controller: 'RegistrasiSuksesController',
        controllerAs: 'vm',
        data: {
          title: 'Registrasi Sukses',
          icon: 'fa-sign-in',
        },
      })

      .state('registrasi-gagal', {
        url: '/registrasi-gagal/:info',
        templateUrl: 'app/registrasi-gagal/registrasi-gagal.html',
        controller: 'RegistrasiGagalController',
        controllerAs: 'vm',
        data: {
          title: 'Registrasi Gagal',
          icon: 'fa-sign-in',
        },
      })

      .state('forgot-password', {
        url: '/forgot-password',
        templateUrl: 'app/forgot-password/forgot-password.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'vm',
        data: {
          title: 'Lupa Password',
          icon: 'fa-lock',
        },
      })

      .state('resetpassword', {
        url: '/reset-password/:token',
        templateUrl: 'app/resetpassword/resetpassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'vm',
        data: {
          title: 'Reset Password',
          icon: 'fa-lock',
        },
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false, _: false, saveAs:false, Papa:false, */
(function() {
  'use strict';

  angular
    .module('oresell')
    .constant('moment', moment)
    .constant('_', _)
    .constant('saveAs', saveAs)
    .constant('Papa', Papa)
    .constant('PROTOCOL', 'https')
    .constant('APIDOMAIN', 'reseller.ethica-collection.com')
    .constant('BASEURL', '/api/')
    .constant('TIMEOUT', 180000)
    .constant('VERSION', '1.14.0')
    .constant('BUILD', '20250227')
    .constant('TODAY', new Date())
    .constant('PER_PAGE', 10)
    .constant('PER_REQUEST', 100)
    .constant('CAPCHA_KEY', '6Lc40DwUAAAAAA8jEM38l9B3JoGQvcIoQWq14T1r');
})();

(function() {
  'use strict';

  angular
    .module('oresell')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, $httpProvider, toastrConfig, jwtOptionsProvider, APIDOMAIN, $qProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    /* Hilangkan # di akhir url */
    $locationProvider.html5Mode(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 10000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.preventOpenDuplicates = true;
    toastrConfig.progressBar = true;

    // storeProvider.setStore('sessionStorage');

    // jwtOptionsProvider.config({ whiteListedDomains: [APIDOMAIN] });

    jwtOptionsProvider.config({
      tokenGetter: ['store', function(store) {
        return store.get('oresell_token');
      }],
      whiteListedDomains: [APIDOMAIN]
    });

    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push('AuthInterceptor');

    /** Temporary measure to remove annoying error warning */
    $qProvider.errorOnUnhandledRejections(false);

  }

})();

angular.module("oresell").run(["$templateCache", function($templateCache) {$templateCache.put("app/forgot-password/forgot-password.html","<div class=\"container-fluid login-container\"><div class=row><div class=\"col-sm-4 col-sm-offset-4 login-box-me text-center\"><h1 class=login-title>Otoresell</h1><h4>Sistem Reseller Ethica Collection</h4><img src=assets/images/logo.png alt=Logo class=img-responsive style=margin:auto;width:30%;margin-top:1em><h4>Lupa Password</h4><hr><form class=form name=loginForm style=\"margin-top: 1em\" ng-if=!vm.finishRequest><div class=form-group><input type=email class=\"form-control input-lg\" placeholder=Email autofocus required ng-model=vm.user.email minlength=4 maxlength=60 name=username></div><hr class=hr-no-margin><div class=form-group style=\"margin-top: 1em\"><button type=submit class=\"btn btn-primary btn-lg btn-block\" ng-disabled=loginForm.$invalid ng-click=vm.prepareRequestResetPassword()><span ng-if=vm.inProcess><i class=\"fa fa-spinner fa-pulse fa-spin\"></i></span> RESET PASSWORD</button></div><div class=form-group><label for=\"\"><a href=\"\" ui-sref=login>Kembali ke halaman login</a></label></div></form><div class=form-group ng-if=!vm.finishRequest><div vc-recaptcha key=vm.capchaKey size=invisible on-create=vm.capcha.setId(widgetId) on-expire=vm.capcha.reload() on-success=vm.capcha.success(response) lang=id></div></div><div ng-if=vm.finishRequest><h2>Permintaan Reset Password Berhasil</h2><p><strong>Kami telah mengirimkan informasi cara untuk mengubah password Anda ke alamat email <a href=\"\">{{vm.user.email}}</a>. Silahkan ikuti instruksi yang ada di dalam email tersebut untuk membuat password baru akun Anda.</strong></p><hr><h3><strong><a href=\"\" ui-sref=login>Kembali ke halaman login</a></strong></h3></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"container-fluid login-container\"><!--<div class=\"row\">\n      <div class=\"col-xs-12 text-center\">\n        <h1>oresell</h1>\n        <h3>Bla bdalkjl jdlkaj ajdaslk lkdjalkj lkajda</h3>\n      </div>\n    </div>--><div class=row><div class=\"col-sm-4 col-sm-offset-4 login-box-me text-center\"><h1 class=login-title>Otoresell</h1><h4>Sistem Reseller Ethica Collection</h4><img src=assets/images/logo.png alt=Logo class=img-responsive style=margin:auto;width:30%;margin-top:1em><hr><form class=form name=loginForm style=\"margin-top: 1em\"><!-- <div ng-messages=\"loginForm.username.$error\" class=\"w_error\">\n                  <div ng-message=\"pattern\">Nama host salah.</div>\n                </div> --><div class=form-group><input type=email class=\"form-control input-lg\" placeholder=Email autofocus required ng-model=vm.user.uname minlength=4 maxlength=60 name=username></div><div class=form-group><input type=password class=\"form-control input-lg\" placeholder=Password required ng-model=vm.user.password minlength=6 maxlength=50 name=password></div><!-- <ul ng-messages=\"loginForm.password.$error\" class=\"w_error text-left\">\n                  <li ng-message=\"minlength\">Panjang minimal 6 karakter</li>\n                  <li ng-message=\"maxlength\">Panjang maksimal 50 karakter</li>\n                </ul> --><hr class=hr-no-margin><div class=form-group style=\"margin-top: 1em\"><button type=submit class=\"btn btn-primary btn-lg btn-block\" ng-disabled=loginForm.$invalid ng-click=vm.prepareLogin()><span ng-if=vm.inProcess><i class=\"fa fa-spinner fa-pulse fa-spin\"></i></span> L O G I N</button></div><div class=form-group><label for=\"\"><a href=\"\" ui-sref=forgot-password>Lupa Password ? Klik di sini !</a></label></div></form><div class=form-group><div vc-recaptcha key=vm.capchaKey size=invisible on-create=vm.capcha.setId(widgetId) on-expire=vm.capcha.reload() on-success=vm.capcha.success(response) lang=id></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"hold-transition skin-blue sidebar-mini\" ng-class=\"main.sidebarCollapse ? \'sidebar-collapse\' : \'\'\"><div class=wrapper><!-- Main Header --><header class=main-header><!-- Logo --> <a href=# class=logo><!-- mini logo for sidebar mini 50x50 pixels --> <span class=logo-mini><b>O</b>res</span><!-- logo for regular state and mobile devices --> <span class=logo-lg><b>Oto</b>resell</span> </a><!-- Header Navbar --><nav class=\"navbar navbar-static-top\" role=navigation><!-- Sidebar toggle button--> <a href=# class=sidebar-toggle data-toggle=offcanvas role=button ng-click=main.toggleSidebar()><span class=sr-only>Toggle navigation</span> </a><!-- Navbar Right Menu --><div class=navbar-custom-menu><ul class=\"nav navbar-nav\"><!-- Messages: style can be found in dropdown.less--><li><a href=\"\" ng-click=main.processOrder()><span ng-if=\"main.totalOrder > 0\">Trx: {{ main.totalOrder | number:0}}</span> <i class=\"fa fa-shopping-cart fa-lg\"></i> <span class=\"label label-danger\" ng-if=\"main.totalItem > 0\">{{main.totalItem}}</span></a></li><!-- <li>\n              <a href=\"\" >\n                <i class=\"fa fa-bell fa-lg\"></i>\n                <span class=\"label label-danger\">1</span>\n              </a>\n            </li> --><li><a href=\"\" ng-click=main.refreshBalance()><span ng-if=main.isCheckBalance><i class=\"fa fa-refresh fa-spin\"></i> cek saldo ...</span> <span ng-if=!main.isCheckBalance><i class=\"fa fa-database fa-lg\"></i> Saldo {{main.user.balance | number: 0 }}</span></a></li><li><a ui-sref=main.inbox><i class=\"fa fa-envelope-o fa-lg\"></i> <span class=\"label label-danger\" ng-if=\"main.totalInbox > 0\">{{main.totalInbox}}</span></a></li><!-- User Account Menu --><li class=\"dropdown user user-menu\" uib-dropdown><!-- Menu Toggle Button --> <a href=# class=dropdown-toggle data-toggle=dropdown uib-dropdown-toggle><!-- The user image in the navbar--><!--<img src=\"assets/images/1.png\" ng-src=\"assets/images/avatars/{{main.user.detail.icon}}\" class=\"user-image\" style=\"border: 1px solid #cecece;\" alt=\"User Image\">--> <i class=\"fa fa-user fa-lg\"></i><!-- hidden-xs hides the username on small devices so only the image appears. --> <span class=hidden-xs><span ng-if=!main.user.name>{{main.user.username}}</span> <span ng-if=main.user.name>{{main.user.name}}</span></span></a><ul class=dropdown-menu uib-dropdown-menu><!-- The user image in the menu --><li class=user-header><img src=assets/images/1.png ng-src=assets/images/avatars/{{main.user.detail.icon}} class=img-circle alt=\"User Image\"><p><span ng-if=main.user.name>{{main.user.name}}</span> <small>{{main.user.email}}</small> <small>{{main.user.username}}</small></p></li><li class=user-footer><!--<div class=\"row\">\n                    <div class=\"col-sm-4\"><a href=\"#\" class=\"btn btn-default btn-flat\" ng-click=\"main.changePassword()\">Password</a></div>\n                    <div class=\"col-sm-4\"><a href class=\"btn btn-default btn-block btn-flat\" ng-click=\"main.logout()\">Logout</a></div>\n                  </div>--><div class=pull-left><a href=# class=\"btn btn-default btn-flat\" ng-click=main.userProfile()>Profil</a></div><div class=pull-right><a href class=\"btn btn-default btn-flat\" ng-click=main.logout()>Logout</a></div></li></ul></li></ul></div></nav></header><!-- Left side column. contains the logo and sidebar --><aside class=main-sidebar><!-- sidebar: style can be found in sidebar.less --><section class=sidebar><!-- Sidebar Menu --><ul class=sidebar-menu><li class=header>MAIN MENU</li><!-- Optionally, you can add icons to the links --><li ng-repeat=\"item in main.menuItem\" ng-class=\"{treeview: item.child, active: main.isActive(item)}\"><a href ui-sref={{item.sref}} ng-if=!item.child><i class=\"fa fa-fw {{::item.icon}}\"></i> <span>{{::item.text}}</span> </a><a href ng-if=item.child><i class=\"fa fa-fw {{::item.icon}}\"></i> <span>{{::item.text}}</span> <span class=pull-right-container ng-if=item.child ng-click=main.changeCollapse(item)><i class=\"fa fa-fw pull-right\" ng-class=\"main.isCollapsed ? \'fa-angle-left\' : \'fa-angle-down\'\"></i></span></a><ul class=treeview-menu uib-collapse=main.isCollapsed ng-if=item.child><li ng-repeat=\"child in item.child\" ng-class=\"{active: main.isActive(child)}\"><a href ui-sref={{child.sref}}><i class=\"fa fa-fw {{::child.icon}}\"></i> {{::child.text}}</a></li></ul></li></ul><!-- /.sidebar-menu --></section><!-- /.sidebar --></aside><!-- Content Wrapper. Contains page content --><div class=content-wrapper><!-- Content Header (Page header) --><section class=content-header ng-class=activeState.data.style><h1><i class=\"fa {{activeState.data.icon}}\"></i> {{activeState.data.title}}<!--<small>Optional description</small>--></h1><!-- <hr class=\"hr-no-margin-bottom hr-color-other\"> --></section><!-- Main content --><section class=content><!-- Your Page Content Here --><div ui-view></div></section><!-- /.content --></div><!-- /.content-wrapper --><!-- Main Footer --><footer class=main-footer><!-- To the right --><!--<div class=\"pull-right hidden-xs\">\n        <strong><a ui-sref=\"main.privacy\">Privacy Policy</a> | <a ui-sref=\"main.disclaimer\">Disclaimer</a></strong>\n      </div>--><!-- Default to the left --> <strong>Copyright &copy; {{::main.copyright.year}} <a href={{::main.copyright.url}} target=_blank>{{::main.copyright.company}}</a>.</strong></footer></div><!-- ./wrapper --></div><div class=loading-animation><div class=cssload-thecube><div class=\"cssload-cube cssload-c1\"></div><div class=\"cssload-cube cssload-c2\"></div><div class=\"cssload-cube cssload-c4\"></div><div class=\"cssload-cube cssload-c3\"></div></div></div>");
$templateCache.put("app/registrasi/registrasi.html","<div class=\"container-fluid login-container\"><div class=row><div class=\"col-sm-8 col-sm-offset-2 login-box-me text-center\"><img src=assets/images/logo.png alt=Logo class=img-responsive style=margin:auto;width:15%;margin-top:1em><h1 class=registrasi-title>Registrasi Reseller</h1><!-- <h4>Sistem Reseller Ethica Collection</h4> --><hr><form class=form name=registrationForm style=\"margin-top: 1em\"><div class=row><div class=col-xs-12><div class=form-group><input type=text class=\"form-control input-lg\" placeholder=Nama autofocus required ng-model=vm.user.name minlength=4 maxlength=60 name=name></div></div></div><div class=row><div class=col-sm-6><div class=form-group><input type=email class=\"form-control input-lg\" placeholder=\"Email (gunakan Gmail)\" autofocus required ng-model=vm.user.email minlength=4 maxlength=60 name=email uib-tooltip=\"Masukkan alamat email yang aktif. Disarankan menggunakan Gmail\"></div></div><div class=col-sm-6><div class=form-group><input type=text class=\"form-control input-lg\" placeholder=\"Nomor HP\" autofocus required ng-model=vm.user.phone minlength=6 maxlength=15 name=phone ng-pattern=vm.pattern.number uib-tooltip=\"Masukkan nomor HP yang aktif\"></div></div></div><hr class=hr-no-margin-top><div class=row><div class=col-sm-6><div class=form-group><input type=password class=\"form-control input-lg\" placeholder=Password required ng-model=vm.user.password minlength=6 maxlength=50 name=password></div></div><div class=col-sm-6><div class=form-group><input type=password class=\"form-control input-lg\" placeholder=\"Konfirmasi Password\" required ng-model=vm.user.confirm_password minlength=6 maxlength=50 name=confirm_password ng-pattern=vm.user.password></div></div></div><div class=row><div class=\"col-xs-12 text-left\"><ul ng-messages=registrationForm.name.$error class=w_error><li ng-message=minlength>Nama: Panjang minimal 4 karakter</li><li ng-message=maxlength>Nama: Panjang maksimal 60 karakter</li></ul><ul ng-messages=registrationForm.email.$error class=w_error><li ng-message=email>Masukkan alamat email yang benar.</li><li ng-message=minlength>Email: Panjang minimal 4 karakter</li><li ng-message=maxlength>Email: Panjang maksimal 60 karakter</li></ul><ul ng-messages=registrationForm.phone.$error class=w_error><li ng-message=pattern>Telepon: Hanya boleh diisi angka</li><li ng-message=minlength>Telepon: Panjang minimal 6 digit</li><li ng-message=maxlegth>Telepon: Panjang maksimal 15 digit</li></ul><ul ng-messages=registrationForm.password.$error class=w_error><li ng-message=minlength>Panjang minimal 6 karakter</li><li ng-message=maxlength>Panjang maksimal 50 karakter</li></ul><ul ng-messages=registrationForm.confirm_password.$error class=w_error><li ng-message=minlength>Panjang minimal 6 karakter</li><li ng-message=maxlength>Panjang maksimal 50 karakter</li><li ng-message=pattern>Tidak cocok dengan password</li></ul></div></div><hr class=hr-no-margin><div class=row><div class=col-xs-12><button type=submit class=\"btn btn-primary btn-lg btn-block\" ng-disabled=registrationForm.$invalid ng-click=vm.doRegistration() style=\"margin-top: 1em\" id=proses_registrasi><span ng-if=vm.inProcess><i class=\"fa fa-spinner fa-pulse fa-spin\"></i></span> PROSES REGISTRASI</button></div></div></form></div></div></div>");
$templateCache.put("app/registrasi-gagal/registrasi-gagal.html","<div class=\"container-fluid login-container\"><div class=row><div class=\"col-sm-8 col-sm-offset-2 login-box-gagal text-center\"><img src=assets/images/logo.png alt=Logo class=img-responsive style=margin:auto;width:15%;margin-top:1em><h1 class=registrasi-title>Registrasi Reseller</h1><!-- <h4>Sistem Reseller Ethica Collection</h4> --><hr><div class=row><div class=col-xs-12><div class=\"well well-gagal\"><h3 class=text-danger>Registrasi Gagal.</h3><br><p><span ng-bind-html=vm.info.msg></span>, atau hubungi <strong>Customer Service</strong> kami.</p><hr><button class=\"btn btn-lg btn-danger\" ui-sref=registrasi>Kembali ke Halaman Registrasi</button></div></div></div></div></div></div>");
$templateCache.put("app/registrasi-sukses/registrasi-sukses.html","<div class=\"container-fluid login-container\"><div class=row><div class=\"col-sm-8 col-sm-offset-2 login-box-sukses text-center\"><img src=assets/images/logo.png alt=Logo class=img-responsive style=margin:auto;width:15%;margin-top:1em><h1 class=registrasi-title>Registrasi Reseller</h1><!-- <h4>Sistem Reseller Ethica Collection</h4> --><hr><div class=row><div class=col-xs-12><div class=\"well well-sukses\"><h3>Registrasi Berhasil.</h3><!-- <span class=\"text-success\"><i class=\"fa fa-thumbs-up fa-3x\"></i></span> --><br><p>Info lengkap silahkan cek email <a href>{{vm.info.email}}</a>. Jika tidak terdapat di inbox, cek juga folder spam.</p><hr><button class=\"btn btn-lg btn-danger\" ui-sref=login>Login di Sini</button></div></div></div></div></div></div>");
$templateCache.put("app/registrasi-tutup/registrasi-tutup.html","<div class=\"container-fluid login-container\"><div class=row><div class=\"col-sm-8 col-sm-offset-2 login-box-sukses text-center\"><img src=assets/images/logo.png alt=Logo class=img-responsive style=margin:auto;width:15%;margin-top:1em><hr><div class=row><div class=col-xs-12><div class=\"well well-info\"><h2 class=text-danger>PENDAFTARAN DITUTUP</h2><br><h3>Maaf, pendaftaran reseller <strong>untuk sementara kami tutup</strong>.</h3><h4>Pendaftaran akan kami buka kembali setelah lebaran.</h4><hr><button class=\"btn btn-lg btn-danger\" ui-sref=login>Kembali Ke Halaman Login</button></div></div></div></div></div></div>");
$templateCache.put("app/resetpassword/resetpassword.html","<div class=\"container-fluid login-container\"><!--<div class=\"row\">\n      <div class=\"col-xs-12 text-center\">\n        <h1>oresell</h1>\n        <h3>Bla bdalkjl jdlkaj ajdaslk lkdjalkj lkajda</h3>\n      </div>\n    </div>--><div class=row><div class=\"col-sm-4 col-sm-offset-4 login-box-me text-center\"><h1 class=login-title>Otoresell</h1><h4>Sistem Reseller Ethica Collection</h4><img src=assets/images/logo.png alt=Logo class=img-responsive style=margin:auto;width:30%;margin-top:1em><h4>Reset Password Akun: {{vm.user.email}}</h4><hr><form class=form name=loginForm style=\"margin-top: 1em\"><div class=form-group><input type=password class=\"form-control input-lg\" placeholder=\"Password Baru\" required ng-model=vm.user.password minlength=6 maxlength=50 name=password></div><div class=form-group><input type=password class=\"form-control input-lg\" placeholder=\"Konfirmasi Password baru\" required ng-model=vm.user.confirm_password minlength=6 maxlength=50 name=confirm_password ng-pattern=vm.user.password></div><hr class=hr-no-margin><div class=form-group style=\"margin-top: 1em\"><button type=submit class=\"btn btn-primary btn-lg btn-block\" ng-disabled=loginForm.$invalid ng-click=vm.prepareResetPassword()><span ng-if=vm.inProcess><i class=\"fa fa-spinner fa-pulse fa-spin\"></i></span> RESET PASSWORD</button></div></form><div class=form-group><div vc-recaptcha key=vm.capchaKey size=invisible on-create=vm.capcha.setId(widgetId) on-expire=vm.capcha.reload() on-success=vm.capcha.success(response) lang=id></div></div></div></div></div>");
$templateCache.put("app/main/main.contact/main.contact.html","<div class=row><form><div class=\"form-group col-sm-6\"><input type=text class=form-control placeholder=\"Nama atau email\" ng-model=vm.filter.search></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"No HP\" ng-model=vm.filter.by_hp></div><div class=\"col-xs-12 col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\"><i class=\"fa fa-search\"></i></button></div><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.deleteSelectedContacts() type=button style=\"border-right: none\"><i class=\"fa fa-trash\"></i></button></div><!-- <div class=\"btn-group\" role=\"group\">\n              <button class=\"btn btn-default\" ng-click=\"vm.importContact()\" type=\"button\" style=\"border-right: none;\"><i class=\"fa fa-cloud-upload\"></i></button>\n            </div> --><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.editContact() type=button><i class=\"fa fa-user-plus\"></i></button></div></div></div></form></div><hr class=hr-no-margin-top><div class=row ng-if=\"vm.contactList.contact.length === 0\"><div class=col-xs-12><div class=\"alert alert-custom text-center\"><p><strong>Data kontak tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.contactList.contact.length > 0\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th scope=col><input type=checkbox ng-model=vm.check.mainItem ng-change=vm.check.checkAll() uib-tooltip=\"Pilih semua\"></th><th scope=col class=autofit>No</th><th scope=col>Nama</th><th scope=col>Kontak</th><th scope=col>Alamat</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.contactList.contact track by item.id\"><td class=autofit><input type=checkbox ng-model=vm.check.item[$index].status></td><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td class=col-sm-2><a href ng-click=vm.editContact(item)>{{item.nama}}</a></td><td class=col-sm-2><a href=mailto:{{item.email}}>{{item.email}}</a> {{item.hp}}</td><td class=col-sm-6>{{item.alamat}} {{item.kec}} {{item.kab}} {{item.prov}} {{item.kode_pos || \'\'}}</td><td class=col-sm-1><!-- <button class=\"btn btn-default btn-xs\" uib-tooltip=\"Cetak Alamat\" ng-click=\"vm.printContact(item)\"><span class=\"text-info\"><i class=\"fa fa-print fa-fw\"></i></span></button> --> <button class=\"btn btn-default btn-xs pull-right\" uib-tooltip=\"Hapus kontak\" ng-click=vm.deleteContact(item)><span class=text-danger><i class=\"fa fa-trash fa-fw\"></i></span></button></td></tr></tbody></table></div></div></div><hr><div class=row><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\"><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-sm-6 hidden-xs\"><button class=\"btn btn-default btn-block\" disabled>Menampilkan halaman : {{vm.filter.page}}</button></div><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage><span class=hidden-xs>Selanjutnya</span> <i class=\"fa fa-arrow-circle-right\"></i></button></div></div>");
$templateCache.put("app/main/main.deposit/main.deposit.html","<div class=row><form><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Awal</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tglAwal is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" min-date=vm.minDate max-date=vm.filter.tglAkhir readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Akhir</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tglAkhir is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" min-date=vm.filter.tglAwal max-date=vm.today readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><select name=\"\" ng-model=vm.filter.type class=form-control><option value=\"\">Semua Jenis</option><option value=DEPOSIT>Deposit</option><option value=PAYMENT>Pembelian</option><option value=REFUND>Refund</option><option value=FINE>Denda</option><option value=BONUS>Bonus</option></select></div><div class=\"form-group col-sm-2 form-group\"><input type=text class=form-control placeholder=Deskripsi ng-model=vm.filter.description></div><div class=\"col-xs-12 col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default btn-block\" ng-click=\"vm.initView(1, false)\" type=submit title=Cari><i class=\"fa fa-search\"></i> <span class=visible-xs-inline>Cari Mutasi</span></button></div><div class=btn-group role=group><button class=\"btn btn-default btn-block\" ng-click=\"vm.initView(1, true)\" type=button title=Download><i class=\"fa fa-download\"></i> <span class=visible-xs-inline>Download Mutasi</span></button></div></div></div></form></div><hr class=hr-no-margin-top><div class=row ng-if=\"vm.depositList.deposit.length === 0\"><div class=col-xs-12><div class=\"alert alert-custom text-center\"><p><strong>Data mutasi deposit tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.depositList.deposit.length > 0\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Tgl</th><th scope=col>Jenis</th><th scope=col>Deskirpsi</th><th scope=col class=text-right>Debet</th><th scope=col class=text-right>Kredit</th><th scope=col class=text-right>Saldo</th></tr></thead><tbody><tr ng-repeat=\"item in vm.depositList.deposit track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.trx_date | tsdate:\'dd-MM-yyyy\' }}</td><td>{{item.type}}</td><td>{{item.description}}</td><td class=text-right>{{item.debet | number: 2}}</td><td class=text-right>{{item.credit | number: 2}}</td><td class=text-right>{{item.balance | number: 2}}</td></tr></tbody></table></div></div></div><hr><!-- <div class=\"row\">\n  <div class=\"col-sm-3\">\n    <button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button>\n  </div>\n  <div class=\"col-sm-6\"><button class=\"btn btn-default btn-block\" disabled>Menampilkan halaman : {{vm.filter.page}}</button></div>\n  <div class=\"col-sm-3\">\n    <button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=\"vm.isLastPage\">Selanjutnya</button>\n  </div>\n</div> --><div class=row><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\"><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-sm-6 form-inline text-center hidden-xs\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage><span class=hidden-xs>Selanjutnya</span> <i class=\"fa fa-arrow-circle-right\"></i></button></div></div>");
$templateCache.put("app/main/main.deposit-ticket/main.deposit-ticket.html","<form><div class=row><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Awal</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tglAwal is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" min-date=vm.minDate max-date=vm.filter.tglAkhir readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Akhir</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tglAkhir is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" min-date=vm.filter.tglAwal max-date=vm.today readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><select name=\"\" ng-model=vm.filter.type class=form-control><option value=\"\">Semua Status</option><option value=NEW>Baru</option><option value=CANCELED>Batal</option><option value=FINISHED>Selesai</option></select></div><div class=\"col-xs-12 col-sm-2\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default btn-block\" ng-click=\"vm.collapse = !vm.collapse\" type=submit title=\"Tampilkan filter lain\" uib-tooltip=\"Tampilan filter lain\"><i class=\"fa fa-angle-double-down\" ng-if=vm.collapse></i> <i class=\"fa fa-angle-double-up\" ng-if=!vm.collapse></i> <span class=visible-xs-inline>Collapse</span></button></div><div class=btn-group role=group><button class=\"btn btn-default btn-block\" ng-click=\"vm.initView(1, false)\" type=submit title=Cari uib-tooltip=\"Cari tiket\"><i class=\"fa fa-search\"></i> <span class=visible-xs-inline>Cari Tiket</span></button></div></div></div><div class=\"col-xs-12 col-sm-2\"><button class=\"btn btn-danger btn-block\" ng-click=vm.createTicket() type=button title=\"Tambah Deposit\" uib-tooltip=\"Tambah Deposit\"><i class=\"fa fa-plus-circle\"></i> <span>Tambah Deposit</span></button></div></div><div class=row><div uib-collapse=vm.collapse><div class=\"form-group col-sm-3 form-group\"><input type=text class=form-control placeholder=Transfer ng-model=vm.filter.totalTransfer></div><div class=\"form-group col-sm-3 form-group\"><input type=text class=form-control placeholder=\"No Rekening\" ng-model=vm.filter.accountNumber></div><div class=\"form-group col-sm-2 form-group\"><input type=text class=form-control placeholder=Bank ng-model=vm.filter.bank></div></div><!-- <div class=\"col-xs-2 pull-right\">\n      <button\n        class=\"btn btn-info btn-block\"\n        ng-click=\"vm.createTicket()\"\n        type=\"button\"\n        title=\"Topup Deposit\"\n      >\n        <i class=\"fa fa-plus-circle\"></i>\n        <span>Topup Deposit</span>\n      </button>\n    </div> --></div></form><hr class=hr-no-margin-top><div class=row ng-if=\"vm.ticketList.data.length === 0\"><div class=col-xs-12><div class=\"alert alert-custom text-center\"><p><strong>Data topup deposit tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.ticketList.data.length > 0\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col class=autofit>Ticket ID</th><th scope=col>Waktu</th><th scope=col class=text-right>Nominal</th><th scope=col class=text-right>Angka Unik</th><th scope=col class=text-right>Transfer</th><th scope=col>Bank</th><th scope=col>Status</th></tr></thead><tbody><tr ng-repeat=\"item in vm.ticketList.data track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td class=text-right><a href=\"\" ng-click=vm.showTicket(item)>#{{item.id}}</a></td><td>{{item.created_at | tsdate:\'dd-MM-yyyy HH:mm:ss\' }}</td><td class=text-right>{{item.deposit | number: 0}}</td><td class=text-right>{{item.unique_number}}</td><td class=text-right>{{item.total_transfer | number: 0}}</td><td>{{item.bank}}<br>{{item.account_number}} {{item.account_ownner}}</td><td><div class=label ng-class=\"item.status === \'FINISHED\' ? \'label-success\' : item.status === \'CANCELED\' ? \'label-default\' : \'label-primary\'\">{{item.status | topupstatus }}</div></td></tr></tbody></table></div></div></div><hr><!-- <div class=\"row\">\n  <div class=\"col-sm-3\">\n    <button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button>\n  </div>\n  <div class=\"col-sm-6\"><button class=\"btn btn-default btn-block\" disabled>Menampilkan halaman : {{vm.filter.page}}</button></div>\n  <div class=\"col-sm-3\">\n    <button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=\"vm.isLastPage\">Selanjutnya</button>\n  </div>\n</div> --><div class=row><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\"><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-sm-6 form-inline text-center hidden-xs\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage><span class=hidden-xs>Selanjutnya</span> <i class=\"fa fa-arrow-circle-right\"></i></button></div></div>");
$templateCache.put("app/main/main.inbox/main.inbox.html","<div class=row><form><!-- <div class=\"form-group col-sm-6\">\n      <input type=\"text\" class=\"form-control\" placeholder=\"Nama atau email\" ng-model=\"vm.filter.search\" />\n    </div> --><!-- <div class=\"form-group col-sm-4\">\n      <input type=\"text\" class=\"form-control\" placeholder=\"No HP\" ng-model=\"vm.filter.by_hp\" />\n    </div> --><div class=\"col-xs-12 col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit><i class=\"fa fa-search\"></i></button></div><!-- <div class=\"btn-group\" role=\"group\">\n          <button class=\"btn btn-default\" ng-click=\"vm.deleteSelectedContacts()\" type=\"button\" style=\"border-right: none;\">\n            <i class=\"fa fa-trash\"></i>\n          </button>\n        </div>\n        <div class=\"btn-group\" role=\"group\">\n          <button class=\"btn btn-default\" ng-click=\"vm.editContact()\" type=\"button\">\n            <i class=\"fa fa-user-plus\"></i>\n          </button>\n        </div> --></div></div></form></div><hr class=hr-no-margin-top><div class=row ng-if=\"vm.inboxList.length === 0\"><div class=col-xs-12><div class=\"alert alert-custom text-center\"><p><strong>Data inbox tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.inboxList.length > 0\"><div class=col-xs-12><uib-accordion><div uib-accordion-group ng-repeat=\"item in vm.inboxList\" ng-class=\"item.status === 0 ? \'panel-info\':\'panel-default\'\" ng-click=vm.openMessage(item)><uib-accordion-heading><small>{{item.created_at | tsdate:\'dd MMMM yyyy - HH:mm:ss\'}}</small><h5>{{item.title}}</h5></uib-accordion-heading>{{item.message}}</div></uib-accordion></div></div><hr><div class=row><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\"><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-sm-6 hidden-xs\"><button class=\"btn btn-default btn-block\" disabled>Menampilkan halaman : {{vm.filter.page}}</button></div><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage><span class=hidden-xs>Selanjutnya</span> <i class=\"fa fa-arrow-circle-right\"></i></button></div></div>");
$templateCache.put("app/main/main.insight/main.insight.html","<form><div class=row><div class=col-sm-3><select name=\"\" class=form-control ng-model=vm.filter.range ng-change=vm.initView()><option value=2w>2 Minggu terakhir</option><option value=m>1 Bulan terakhir</option><!-- <option value=\"\">2 Bulan terakhir</option> --></select></div></div></form><hr><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.options data=vm.data></nvd3></div></div></div></div>");
$templateCache.put("app/main/main.order/main.order.html","<!--<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <p>Berisi tabel produk. User bisa klik salah satu produk untuk beli produk tsb</p>\n    <p>Produk yg dibeli, disimpan di Shopping Cart, untuk kemudian bisa diproses di shopping cart.</p>\n    <p>Proses di shopping cart meliputi: Edit jumlah, customer, alamat kirim, simpan ke pending, proses ke pembayaran</p>\n  </div>\n</div>--><div class=row><div class=col-xs-12><form><div class=row><div class=\"form-group col-xs-12 col-sm-3\"><!--<label for=\"\" class=\"reqfield\">SKU</label>--> <input type=text class=form-control placeholder=SKU ng-model=vm.filter.by_sku></div><div class=\"form-group col-xs-12 col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=\"Nama Produk\" ng-model=vm.filter.search></div><div class=\"form-group col-xs-12 col-sm-2\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=Ukuran ng-model=vm.filter.by_size></div><div class=\"form-group col-xs-12 col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Kondisi Stok</label>--><select name=filter_only_with_stock id=filter_only_with_stock class=form-control ng-model=vm.filter.only_with_stok><option value=0>Semua Stok</option><option value=1>Hanya Stok yg Tersedia</option><option value=2>Hanya Stok yg Kosong</option></select></div><div class=\"form-group col-xs-12 col-sm-1 pull-right\"><!-- <div class=\"btn-group\" role=\"group\"> --> <button class=\"btn btn-default btn-block\" ng-click=vm.initView(1) type=submit><i class=\"fa fa-search\"></i> <span class=visible-xs-inline>Cari Produk</span></button><!-- </div> --></div></div></form></div></div><hr class=hr-no-margin-top><div class=row ng-if=\"vm.productList.data.length === 0\"><div class=col-xs-12><div class=\"alert alert-custom text-center\"><p><strong>Data produk tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.productList.data.length > 0\"><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th scope=col class=\"hidden-xs hidden-sm\">No</th><th scope=col class=\"hidden-xs hidden-sm\">SKU</th><th scope=col>Nama Produk</th><th scope=col class=\"text-right hidden-xs hidden-sm\">Berat (kg)</th><th scope=col class=text-right>Harga</th><th scope=col class=text-right>Stok</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.productList.data track by item.id\" ng-class=\"{danger: (item.status == \'nw\') || (!item.weight)}\"><td class=\"text-right hidden-xs hidden-sm\">{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td class=\"hidden-xs hidden-sm\">{{item.sku | uppercase}}</td><td><strong><a href={{item.permalink}} target=_blank>{{item.nama}}</a> </strong><small class=\"hidden-md hidden-lg\"><br><strong>SKU:</strong> {{item.sku | uppercase}}</small><br><small>{{item.ket}}</small></td><td class=\"text-right hidden-xs hidden-sm\">{{item.weight | number:2}}</td><td class=text-right><small class=text-old-price>{{item.harga | number:2}}</small><br><strong>{{item.harga_diskon | number:2}}</strong></td><td class=text-right>{{item.jumlah || 0}}</td><td class=autofit><button class=\"btn btn-default btn-sm\" uib-tooltip=Beli ng-click=vm.addToCart(item) ng-disabled=\"item.jumlah === 0\"><i class=\"fa fa-cart-arrow-down\"></i></button></td></tr></tbody></table></div></div><hr><div class=row><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\"><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-sm-6 form-inline text-center hidden-xs\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage><span class=hidden-xs>Selanjutnya</span> <i class=\"fa fa-arrow-circle-right\"></i></button></div></div>");
$templateCache.put("app/main/main.order-closed/main.order-closed.html","<div class=row><div class=\"col-xs-12 text-center\"><h3>Selamat Hari Raya Idul Fitri 1442 H</h3><h1>تَقَبَّلَ اللَّهُ مِنَّا وَ مِنْكُمْ</h1><img src=assets/images/ketupat.jpg alt=ketupat style=\"max-width: 25%\"><p><em>Semoga Allah menerima ibadah Kami dan ibadah Anda</em></p><h1>ORDER DITUTUP</h1><p>Untuk sementara, order kami tutup. Order <em>insya Allah</em> akan kembali dibuka setelah Idul Fitri</p></div></div>");
$templateCache.put("app/main/main.pending/main.pending.html","<form><div class=row><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Awal</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Akhir</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=\"#Id transaksi\" ng-model=vm.filter.by_id></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=\"Nama Pembeli\" ng-model=vm.filter.by_pembeli></div><div class=\"col-xs-12 col-sm-1 pull-right form-group\"><button class=\"btn btn-default btn-block\" ng-click=vm.initView(1) type=submit><i class=\"fa fa-search\"></i> <span class=visible-xs-inline>Cari</span></button></div></div></form><!-- <div class=\"row\">\n  <div class=\"col-sm-4 col-sm-offset-8\"><button class=\"btn btn-warning btn-block\" ng-click=\"vm.downloadTransaction()\" ng-disabled=\"vm.inProcess\" ><i class=\"fa fa-cloud-download\"></i> Download Riwayat Penjualan</button></div>\n</div> --><hr><div class=row ng-if=\"vm.transactionList.length === 0\"><div class=col-xs-12><div class=\"alert alert-custom text-center\"><p><strong>Data pesanan tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.transactionList.length > 0\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th scope=col>No</th><th scope=col>Waktu</th><th scope=col>Order Id</th><th scope=col>Konsumen</th><th scope=col class=text-right>Nilai</th><!-- <th scope=\"col\" >Diskon (Nominal)</th> --><!-- <th scope=\"col\" >Diskon Total</th> --><!-- <th scope=\"col\" >Total</th> --><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.transactionList track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.tgl | tsdate:\'dd-MM-yyyy - HH:mm:ss\'}}</td><!-- <td class=\"text-right\"> <button class=\"btn btn-link btn-block btn-xs\" ng-click=\"vm.showDetail(item.id)\" uib-tooltip=\"Klik untuk lihat detail transaksi\">#{{item.id}}</button></td> --><td class=text-right><button class=\"btn btn-link btn-block btn-xs\" ng-click=vm.processOrder(item) uib-tooltip=\"Klik untuk proses transaksi\">#{{item.id}}</button></td><td><a ng-click=vm.showCustomerDetail(item.cust_uuid) ng-if=item.cust_uuid style=\"cursor: pointer\">{{item.pembeli}}</a></td><td class=text-right>{{ (item.total_akhir * 1)| number:2 }}</td><!-- <td class=\"text-right\" >{{item.discount_nominal | number:2}}</td> --><!-- <td class=\"text-right\" >{{item.discount_total | number:2}}</td> --><!-- <td class=\"text-right\" >{{item.total_akhir | number:2}}</td> --><td class=text-right><button class=\"btn btn-danger btn-xs\" ng-click=vm.cancelOrder(item) uib-tooltip=\"Batalkan transaksi. Warning: Kena denda\" tooltip-placement=left><i class=\"fa fa-times-circle\"></i></button></td></tr></tbody></table></div></div></div><hr><div class=row><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\"><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-sm-6 form-inline text-center hidden-xs\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage><span class=hidden-xs>Selanjutnya</span> <i class=\"fa fa-arrow-circle-right\"></i></button></div></div>");
$templateCache.put("app/main/main.transaction-history/main.transaction-history.html","<form><div class=row><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Awal</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" max-date=vm.filter.tglAkhir readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Akhir</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" min-date=vm.filter.tglAwal datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=#Id ng-model=vm.filter.by_id></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=\"Nama Pembeli\" ng-model=vm.filter.by_pembeli></div><div class=\"col-xs-12 col-sm-1 pull-right form-group\"><button class=\"btn btn-default btn-block\" ng-click=vm.initView(1) type=submit><i class=\"fa fa-search\"></i> <span class=visible-xs-inline>Cari Transaksi</span></button></div></div></form><hr><div class=row ng-if=\"vm.transactionList.length === 0\"><div class=col-xs-12><div class=\"alert alert-custom text-center\"><p><strong>Data riwayat transaksi tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.transactionList.length > 0\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Waktu</th><th scope=col class=\"text-right autofit\">Order Id</th><th scope=col>Pembeli</th><th scope=col class=text-right>Harga Produk</th><th scope=col class=text-right>Total Diskon</th><th scope=col class=text-right>Total Biaya</th><th scope=col class=text-right>Total</th><!--<th scope=\"col\" ></th>--></tr></thead><tbody><tr ng-repeat=\"item in vm.transactionList track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.tgl | tsdate:\'dd-MM-yyyy - HH:mm:ss\'}}</td><td class=text-right><a href id=simple-dropdown ng-click=vm.showDetail(item.id) uib-dropdown-toggle>#{{item.id}}</a></td><td class=text-left><a ng-click=vm.showCustomerDetail(item.cust_uuid) ng-if=item.cust_uuid style=\"cursor: pointer\">{{item.pembeli}}</a></td><td class=text-right>{{ (item.product_price_total * 1) | number:2 }}</td><td class=text-right>{{ ((item.discount_transaction_total * 1) + (item.discount_product_total * 1)) | number:2 }}</td><td class=text-right>{{ (item.total_lain_lain * 1) | number:2 }}</td><td class=text-right>{{ (item.total_akhir * 1) | number: 2 }}</td><!--<td class=\"text-right\" >{{item.kasir}}</td>--></tr></tbody></table></div></div></div><hr><div class=row><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\"><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-sm-6 form-inline text-center hidden-xs\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=\"col-xs-6 col-sm-3\"><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage><span class=hidden-xs>Selanjutnya</span> <i class=\"fa fa-arrow-circle-right\"></i></button></div></div>");
$templateCache.put("app/components/modals/CancelTransaction/CancelTransactionDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Bataklan Transaksi #{{vm.resume.id}}</h4></div><div class=modal-body><h4>Anda yakin hendak membatalkan transaksi berikut ?</h4><p>Membatalkan transaksi ini akan dikenai denda Rp. {{vm.totalFine | number}}.</p><table class=\"table table-striped\"><tr><th scope=row class=col-sm-4>ID</th><td>#{{vm.resume.id}}</td></tr><tr><th scope=row class=col-sm-4>Nama Konsumen</th><td>{{vm.resume.pembeli}}</td></tr><tr><th scope=row class=col-sm-4>Nilai</th><td>{{vm.resume.total_akhir | number:2}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-xs-6 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Proses Batalkan</button></div><div class=col-xs-6><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Kembali</button></div></div></div></div>");
$templateCache.put("app/components/modals/ContactDetail/ContactDetailDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Detail Pelanggan: {{::vm.pelanggan.nama}}</h4></div><div class=modal-body><table class=\"table table-condensed\" ng-if=!vm.noConsumen><tr><th scope=row class=col-sm-3>Nama</th><td>:</td><td>{{::vm.pelanggan.nama}}</td></tr><tr><th scope=row class=col-sm-3>Email</th><td>:</td><td><a ng-href=mailto:{{vm.pelanggan.email}}>{{::vm.pelanggan.email}}</a></td></tr><tr><th scope=row class=col-sm-3>No HP</th><td>:</td><td>{{::vm.pelanggan.hp}}</td></tr><tr><th scope=row class=col-sm-3>No Telepon</th><td>:</td><td>{{::vm.pelanggan.telp}}</td></tr><tr><th scope=row class=col-sm-3>Alamat</th><td>:</td><td>{{::vm.pelanggan.alamat}} {{::vm.pelanggan.kec}} {{::vm.pelanggan.kab}} {{::vm.pelanggan.prov}} {{::vm.pelanggan.kode_pos}}</td></tr><tr><th scope=row class=col-sm-3>Keterangan</th><td>:</td><td>{{::vm.pelanggan.extra.keterangan}}</td></tr></table><div class=\"alert alert-danger\" ng-if=vm.noConsumen>Data pelanggan tidak ada atau sudah dihapus</div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-check-circle\"></i> Selesai</button></div></div></div></div>");
$templateCache.put("app/components/modals/DeleteDialog/DeleteDialog.html","<div><div class=\"modal-header header-danger\"><h4><i class=\"fa fa-trash\"></i> {{vm.data.title}}</h4></div><div class=modal-body><h4>{{vm.data.confirm}}</h4><table class=\"table table-striped\"><tbody><tr ng-repeat=\"col in vm.data.detail\"><th scope=row class=col-sm-4>{{col.fname}}</th><td class=col-sm-8>{{col.value}}</td></tr></tbody></table><div class=\"alert alert-warning\" ng-if=vm.data.effect><p>{{vm.data.effect}}</p></div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/DeleteContact/DeleteContactDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Kontak</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus kontak berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row>Nama</th><td>{{vm.contact.nama}}</td></tr><tr><th scope=row>Email</th><td>{{vm.contact.email}}</td></tr><tr><th scope=row>No HP</th><td>{{vm.contact.hp}}</td></tr><tr><th scope=row>Alamat</th><td>{{vm.contact.alamat}} {{vm.contact.kec}} {{vm.contact.kab}} {{vm.contact.prov}} {{vm.contact.kode_pos}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/DepositTicket/DepositTicket.html","<div><div class=modal-header><h4>Topup Deposit #{{ vm.depositData.id }} <button class=\"btn btn-danger btn-xs pull-right\" ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i></button></h4></div><div class=modal-body><div class=container-fluid ng-if=vm.depositData><div class=row><div class=col-12><p ng-if=\"vm.depositData.status === \'NEW\'\">Silahkan transfer deposit anda sebelum <strong class=text-danger>{{ vm.depositData.expired | tsdate: \'dd MMMM yyyy - HH:mm:ss\' }} WIB.</strong></p><div class=\"alert alert-danger\" ng-if=\"vm.depositData.status === \'CANCELED\'\"><p>Tiket ini telah dibatalkan oleh sistem karena belum transfer sampai batas waktu yg ditentukan (<strong>{{ vm.depositData.expired | tsdate: \'dd MMMM yyyy - HH:mm:ss\' }} WIB.</strong>)</p></div><div class=\"alert alert-success\" ng-if=\"vm.depositData.status === \'FINISHED\'\"><p>Tiket ini telah diproses dan deposit Anda telah ditambahkan</p></div><p ng-if=\"vm.depositData.status === \'TRANSFER\'\">Sistem akan otomatis memeriksa transfer deposit Anda.</p><table class=table><tbody><tr><th scope=row class=col-sm-3>Rekening</th><td><strong>{{vm.depositData.bank}} {{vm.depositData.account_number}}</strong><br>a.n {{vm.depositData.account_name}}</td></tr><tr><th scope=row class=col-sm-3>Total Transfer</th><td>Rp. <strong>{{vm.depositData.total_transfer | number}}</strong></td></tr><tr ng-if=\"vm.depositData.status === \'NEW\'\"><th scope=row class=col-sm-3></th><td>Pastikan transfer <strong>sama persis sampai 3 angka terakhir</strong>.</td></tr></tbody></table><p ng-if=\"(vm.retry < 1) && vm.depositData.status === \'NEW\'\"><strong>Hanya jika sudah transfer</strong>, centang <em>\"Saya sudah transfer\"</em> dan klik <em>\"Konfirmasi\"</em>.</p><div class=\"alert alert-success\" ng-if=\"vm.retry > 0\"><div class=row><div class=\"col-sm-2 text-center\"><i class=\"fa fa-check-circle fa-4x\"></i></div><div class=col-sm-10><p>Konfirmasi Telah diterima. <strong style=\"text-decoration: underline\">Saldo akan masuk dalam waktu 2 menit</strong></p><p>Jika dalam 3 menit saldo belum masuk, <strong>hubungi CS dengan mengirim bukti trasnfer</strong></p></div></div></div></div></div></div><div class=container-fluid ng-if=!vm.depositData><form class=form-horizontal name=depositForm id=depositForm><div class=form-group><label for=deposit class=\"col-sm-4 control-label text-left\">Bank Tujuan</label><div class=col-sm-8><div class=col-sm-4 style=\"border: 1px solid #d2d6de;\n                border-radius: 0.5em;\n                padding-bottom: 10px\"><label class=radio-inline><input type=radio name=bank id=bankBCA value=bca ng-model=vm.depositBank required> <img class=img-responsive style=\"height: 20px\" src=assets/images/bca.svg alt=BCA title=BCA></label></div><div class=col-sm-1></div><div class=col-sm-4 style=\"border: 1px solid #d2d6de;\n                border-radius: 0.5em;\n                padding-bottom: 10px\"><label class=radio-inline><input type=radio name=bank id=bankBRI value=bri ng-model=vm.depositBank required> <img class=img-responsive style=\"height: 20px\" src=assets/images/bri.svg alt=BRI title=BRI></label></div></div></div><div class=form-group><label for=deposit class=\"col-sm-4 control-label text-left\">Nilai Deposit</label><div class=col-sm-8><input type=number class=form-control id=deposit placeholder=\"Contoh: 100000\" min=10000 max=99000000 required ng-model=vm.depositValue ng-pattern=vm.onlyNumbers inputmode=numeric autofocus> <small class=text-danger>Masukkan <strong>angka saja</strong>, tanpa titik pemisah ribuan</small></div></div><!-- <div class=\"form-group\">\n          <label for=\"bank\" class=\"col-sm-4 control-label text-left\">Bank Tujuan Transfer</label>\n          <div class=\"col-sm-8\">\n            <select name=\"bank\" id=\"bank\" class=\"form-control\" ng-model=\"vm.depositBank\" required >\n              <option value=\"bca\">BCA</option>\n              <option value=\"bri\">BRI</option>\n            </select>\n          </div>\n        </div> --><div class=row ng-if=!vm.depositData><div class=col-xs-12><hr class=hr-no-margin-top><button class=\"btn btn-danger btn-block btn-lg\" type=button ng-click=vm.createDeposit() ng-disabled=depositForm.$invalid><i class=\"fa fa-save\"></i> Tambahkan Deposit</button></div><div class=\"col-xs-6 col-sm-4\"></div></div></form></div></div><div class=modal-footer ng-if=\"(vm.retry < 1) && vm.depositData && vm.depositData.status === \'NEW\'\"><div class=row><div class=\"col-xs-6 col-sm-8\"><div class=\"checkbox text-left\"><label><input type=checkbox ng-model=vm.checkConfirm> Saya sudah transfer</label></div></div><div class=\"col-xs-6 col-sm-4 pull-right\"><button class=\"btn btn-info btn-block\" type=button ng-click=vm.confirmTransfer() ng-disabled=\"vm.disabled || !vm.checkConfirm || vm.retry > 0\"><i class=\"fa fa-save\"></i> Konfirmasi</button></div></div></div></div>");
$templateCache.put("app/components/modals/EditContact/EditContactDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Kontak</h4></div><div class=modal-body><form action=\"\" class=form name=contactForm><div class=row><div class=\"col-xs-12 col-sm-2 form-group\"><select name=\"\" id=jenis_kelamin class=form-control ng-model=vm.contact.kelamin><option value=P>Ibu</option><option value=L>Bpk</option></select></div><div class=\"col-xs-12 col-sm-10 form-group\"><input type=text class=form-control placeholder=\"Nama Lengkap\" ng-model=vm.contact.nama maxlength=35 required></div></div><hr class=hr-no-margin-top><div class=row><div class=\"col-xs-12 col-sm-4 form-group\"><input type=text class=form-control placeholder=\"Nomor HP\" ng-model=vm.contact.hp required ng-pattern=vm.alamat.validasi.nomor></div><div class=\"col-xs-12 col-sm-4 form-group\"><input type=text class=form-control placeholder=\"Nomor Telepon lain\" ng-model=vm.contact.telp ng-pattern=vm.alamat.validasi.nomor></div><div class=\"col-xs-12 col-sm-4 form-group\"><input type=email class=form-control placeholder=Email ng-model=vm.contact.email></div></div><hr class=hr-no-margin-top><div class=row><div class=\"form-group col-xs-12\"><input type=text class=form-control placeholder=Alamat ng-model=vm.contact.alamat required></div></div><div class=row><div class=\"col-xs-12 col-sm-10 form-group\"><ui-select ng-model=vm.alamat.kecamatan required><ui-select-match placeholder=Kecamatan><span>{{$select.selected.subdistrict_name}} {{$select.selected.type}} {{$select.selected.city}} - {{$select.selected.province}}</span></ui-select-match><ui-select-choices repeat=\"kec in (vm.alamat.source.kecamatan | filter: $select.search)\" refresh=vm.searchSubdistrict($select.search) refresh-delay=300 minimum-input-length=3><span><strong>{{kec.subdistrict_name}} {{kec.type}} {{kec.city}}</strong></span><br><small>{{kec.province}}</small></ui-select-choices></ui-select></div><div class=\"col-xs-12 col-sm-2 form-group\"><input type=text class=form-control placeholder=\"Kode Pos\" ng-model=vm.contact.kode_pos maxlength=5 ng-pattern=vm.alamat.validasi.nomor></div></div><hr class=hr-no-margin-top><div class=row><div class=\"col-xs-12 form-group\"><textarea class=form-control placeholder=Keterangan... rows=3 ng-model=vm.contact.extra.keterangan></textarea></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-xs-6 col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.save() ng-disabled=contactForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=\"col-xs-6 col-sm-4\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/MassDeleteContact/MassDeleteContactDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Kontak yang Dipilih</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus kotak yang dipilih ?</h4></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/ProcessOrder/ProcessOrderDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-shopping-cart\"></i> Detail Order <span ng-if=vm.order.id>#{{ vm.order.id }}</span> <button class=\"btn btn-danger btn-xs pull-right\" ng-click=vm.cancel() ng-disabled=vm.inProgress><i class=\"fa fa-times-circle\"></i></button></h4></div><div class=modal-body><div ng-if=\"vm.currStep === 0\"><div class=row><div class=col-xs-12><h4>Tahap 1: Produk</h4></div></div><hr class=hr-no-margin><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th scope=col class=\"text-right autofit hidden-xs hidden-sm\">No</th><th scope=col class=\"hidden-xs hidden-sm\">SKU</th><th scope=col>Nama</th><th scope=col class=\"text-right autofit hidden-xs hidden-sm\">Berat (kg)</th><th scope=col class=text-right>Harga</th><th scope=col class=\"text-right hidden-xs\">Stok</th><th scope=col class=\"text-right col-xs-2 col-sm-1\">Jumlah</th><th scope=col class=\"text-right col-sm-2\">Total</th><th scope=col class=autofit></th></tr></thead><tbody><tr ng-repeat=\"item in vm.produk_jual track by item.produk_id\" ng-class=\"{\'danger\': item.noStock}\"><td class=\"autofit text-right hidden-xs hidden-sm\">{{ $index + 1 }}</td><td class=\"autofit hidden-xs hidden-sm\">{{ item.sku }}</td><td><strong>{{ item.nama }}</strong><br><small>{{item.ket}}</small></td><td class=\"text-right hidden-xs hidden-sm\">{{ item.weight | number: 2 }}</td><td class=text-right><small class=text-old-price>{{ item.harga | number: 0 }}</small><br><strong>{{ item.harga_diskon | number: 0 }}</strong></td><td class=\"text-right hidden-xs\">{{ item.stock }}</td><td class=\"text-right col-xs-2 col-sm-1\"><input type=number min=1 ng-locale-number fraction=0 class=\"form-control col-xs-2 text-right input-in-table input-number\" ng-model=item.jumlah min=1 ng-change=vm.changeItemQty(item)></td><td class=text-right><strong>{{ item.harga_diskon * (item.jumlah * 1) | number: 0 }}</strong></td><td class=autofit><button class=\"btn btn-default btn-sm\" uib-tooltip=\"Hapus item\" ng-click=\"vm.deleteItem($index, item)\" ng-disabled=vm.inProgress><span class=text-danger><i class=\"fa fa-trash\"></i></span></button></td></tr><tr><td class=\"hidden-xs hidden-sm\"></td><td class=\"hidden-xs hidden-sm\"></td><td></td><td class=\"hidden-xs hidden-sm\"></td><td class=text-right><strong>Jumlah</strong></td><td class=hidden-xs></td><td class=text-right><strong>{{ vm.resume.totalQty | number: 0 }}</strong></td><td class=text-right><strong>{{ vm.resume.totalPrice | number: 0 }}</strong></td><td></td></tr></tbody></table></div></div></div><div ng-if=\"vm.currStep === 1\"><div class=row><div class=col-xs-12><h4>Tahap 2: Konsumen &amp; Ongkir</h4></div></div><hr class=hr-no-margin-top><div class=row uib-collapse=\"vm.selectedContact.id === 0\"><div class=col-xs-12><div class=form-group><ui-select ng-model=vm.selectedContact autofocus ng-required=!vm.additionalUI.newCust ng-change=vm.changeCustomer()><ui-select-match placeholder=\"Nama Konsumen...\"><span>{{ $select.selected.nama }}</span></ui-select-match><ui-select-choices repeat=\"contact in (vm.contactList) track by contact.id\" refresh=vm.getCustomerContact($select.search) refresh-delay=300 minimum-input-length=3><div ng-if=!contact.info><span><strong>{{ contact.nama }}</strong></span><br><small ng-if=contact.email>Email : {{ contact.email }}<br></small><small ng-if=contact.hp>HP : {{ contact.hp }}</small></div><div ng-if=contact.info><strong ng-bind=contact.nama></strong><br><span ng-bind=contact.info></span></div></ui-select-choices></ui-select></div></div></div><div class=\"alert alert-custom\" style=\"position: relative\" uib-collapse=\"(!vm.selectedContact.id) || (vm.selectedContact.id === 0)\"><p><strong>{{ vm.selectedContact.nama }}</strong></p><p>{{ vm.selectedContact.alamat }} {{ vm.selectedContact.kec }}<br>{{ vm.selectedContact.kab }} - {{ vm.selectedContact.prov }} {{ vm.selectedContact.kode_pos || \'\' }}</p><p><span ng-if=vm.selectedContact.hp>No HP: {{ vm.selectedContact.hp }}</span> <span ng-if=vm.selectedContact.telp>- No. Telp: {{ vm.selectedContact.telp }}</span> <span ng-if=vm.selectedContact.email>- Email: <a href=\"mailto:{{ vm.selectedContact.email }}\">{{ vm.selectedContact.email }}</a></span></p><span style=\"position: absolute; top: 1em; right: 1em\"><button class=\"btn btn-default btn-lg pull-right\" ng-click=vm.editContact() ng-disabled=vm.inProgress><i class=\"fa fa-edit fa-lg\"></i></button></span></div><div class=\"alert alert-custom\" uib-collapse=\"vm.selectedContact.id !== 0\"><div class=row><div class=col-xs-12><h5><span ng-if=vm.newContact.id>Edit</span> Data Kontak <span ng-if=!vm.newContact.id>Baru</span></h5></div></div><hr class=hr-no-margin-top><form name=contactForm id=contactForm><div class=row><div class=col-sm-2><div class=form-group><select name=\"\" class=form-control ng-model=vm.newContact.kelamin ng-init=\"vm.newContact.kelamin = \'P\'\"><option value=P>Ibu</option><option value=L>Bapak</option></select></div></div><div class=col-sm-10><div class=form-group><input type=text class=form-control placeholder=Nama ng-model=vm.newContact.nama required maxlength=35 autofocus></div></div></div><div class=row><div class=col-sm-4><div class=form-group><input type=text class=form-control placeholder=\"Nomor HP\" ng-model=vm.newContact.hp maxlength=13 ng-pattern=vm.onlyNumbers required></div></div><div class=col-sm-4><div class=form-group><input type=text class=form-control placeholder=\"Nomor Telepon\" ng-model=vm.newContact.telp maxlength=15 ng-pattern=vm.onlyNumbers></div></div><div class=col-sm-4><div class=form-group><input type=email class=form-control placeholder=Email ng-model=vm.newContact.email maxlength=255></div></div></div><div class=row><div class=col-sm-8><div class=form-group><input type=text class=form-control placeholder=Alamat ng-model=vm.newContact.alamat maxlength=255 required></div></div><div class=col-sm-4><div class=form-group><input type=text class=form-control placeholder=\"Kode Pos\" ng-model=vm.newContact.kode_pos maxlength=5 ng-pattern=vm.onlyNumbers></div></div></div><div class=row><div class=col-sm-12><div class=form-group><ui-select ng-model=vm.selectedKec required><ui-select-match placeholder=Kecamatan><span>{{ $select.selected.subdistrict_name }} {{ $select.selected.type }} {{ $select.selected.city }} - {{ $select.selected.province }}</span></ui-select-match><ui-select-choices repeat=\"kec in (vm.listKecamatan | filter: $select.search)\" refresh=vm.searchSubdistrict($select.search) refresh-delay=300 minimum-input-length=3><span><strong>{{ kec.subdistrict_name }} {{ kec.type }} {{ kec.city }}</strong><br><small>{{ kec.province }}</small></span></ui-select-choices></ui-select></div></div></div></form><hr class=hr-no-margin-top><div class=row><div class=col-sm-4><button class=\"btn btn-block btn-danger\" ng-click=vm.cancelNewContact() ng-disabled=vm.inProgress><i class=\"fa fa-close\"></i> Batal</button></div><div class=col-sm-4></div><div class=col-sm-4><button class=\"btn btn-block btn-primary\" ng-click=vm.saveNewContact() ng-disabled=\"contactForm.$invalid || vm.inProgress\"><i class=\"fa fa-save\"></i> Simpan Kontak</button></div></div></div><!-- Info ongkir --><div uib-collapse=\"(!vm.selectedContact.id) || (vm.selectedContact.id === 0)\"><hr class=hr-no-margin><h5>Ongkos Kirim</h5><div class=row uib-collapse=\"vm.statusOngkir !== 0\"><div class=\"col-xs-12 text-center\"><br><i class=\"fa fa-spinner fa-pulse fa-3x fa-spin\"></i><h5>Loading data ongkos kirim</h5></div></div><div class=row uib-collapse=\"vm.statusOngkir !== -1\"><div class=\"col-xs-12 text-center\"><br><h5>Gagal mendapatkan data ongkos kirim</h5><button class=\"btn btn-default\" ng-click=vm.getCost()><i class=\"fa fa-refresh\"></i> Coba Lagi</button></div></div><div class=row uib-collapse=\"vm.statusOngkir < 1\"><div class=col-xs-12><div ng-repeat=\"ongkir in vm.ongkir\" class=panel ng-class=\"ongkir.code === \'online\' ? \'panel-danger\' : \'panel-default\'\"><div class=panel-heading><h4 class=panel-title>{{ ongkir.name }}</h4></div><div class=panel-body><div class=\"alert alert-danger\" ng-if=\"ongkir.code === \'pos\'\">Pengiriman via POS dikenakan biaya asuransi Rp. 500</div><div class=radio ng-repeat=\"biaya in ongkir.costs\"><label><input type=radio name=OptionOngkir value=\"{{ongkir.code}}-{{ biaya.service }}\" ng-click=\"vm.setShippingCost({name: ongkir.code, service: biaya})\" ng-model=vm.optionOngkir> {{ ongkir.code | uppercase }} {{ biaya.description }} <strong>{{ biaya.cost[0].value | number: 0 }}</strong></label></div></div></div></div></div><div class=row uib-collapse=\"vm.statusOngkir !== 1\"><div class=col-xs-4></div><div class=col-xs-4><button class=\"btn btn-block btn-primary\" ng-click=vm.getMoreExpedition()><i class=\"fa fa-arrow-down\"></i> Ekspedisi other</button></div></div></div></div><div ng-if=\"vm.currStep === 2\"><div class=row><div class=col-xs-12><h4>Tahap 3: Resume</h4></div></div><hr class=hr-no-margin-top><div class=row><div class=col-sm-8><div class=\"alert alert-custom\"><!-- <h5>Konsumen</h5> --><p><strong>{{ vm.selectedContact.nama }}</strong></p><p>{{ vm.selectedContact.alamat }} {{ vm.selectedContact.kec }}<br>{{ vm.selectedContact.kab }} - {{ vm.selectedContact.prov }} {{ vm.selectedContact.kode_pos || \'\' }}</p><p><span ng-if=vm.selectedContact.hp>No HP: {{ vm.selectedContact.hp }}</span> <span ng-if=vm.selectedContact.telp>- No. Telp: {{ vm.selectedContact.telp }}</span> <span ng-if=vm.selectedContact.email>- Email: <a href=\"mailto:{{ vm.selectedContact.email }}\">{{ vm.selectedContact.email }}</a></span></p></div></div><div class=col-sm-4><div class=\"alert alert-custom\"><!-- <h5>Pengirim</h5> --> <span ng-if=!vm.customSender.use><p><strong>{{ vm.dataReseller.nama }}</strong></p><p><i class=\"fa fa-phone-square\"></i> {{ vm.dataReseller.hp }}</p></span><span ng-if=vm.customSender.use><button class=\"btn btn-sm btn-danger\" ng-click=\"vm.customSender.use = !vm.customSender.use\" style=\"position: absolute; right: 1.2em; top: 0\" uib-tooltip=\"Hapus data custom. Kembali gunakan data profil\" tooltip-placement=left ng-disabled=vm.inProgress><span><i class=\"fa fa-times-circle\"></i></span></button><form name=customSenderForm id=customSenderForm style=\"margin-top: 1.5em; margin-bottom: -1em\"><div class=input-group><span class=input-group-addon id=basic-addon1><i class=\"fa fa-user fa-fw\"></i></span> <input type=text class=form-control placeholder=\"Nama ...\" ng-model=vm.customSender.nama required minlength=3 uib-tooltip=\"Masukkan nama pengirim\"></div><div class=form-group><div class=input-group><span class=input-group-addon id=basic-addon1><i class=\"fa fa-phone-square fa-fw\"></i></span> <input type=text class=form-control placeholder=\"No HP ...\" ng-model=vm.customSender.hp required ng-pattern=vm.onlyNumbers minlength=9 uib-tooltip=\"Masukkan nomor HP pengirim\"></div></div></form></span><span style=\"position: absolute; top: 1em; right: 2em\" ng-if=!vm.customSender.use><button class=\"btn btn-default btn-sm pull-right\" ng-click=\"vm.customSender.use = !vm.customSender.use\" uib-tooltip=\"Gunakan Nama dan No HP Custom\" tooltip-append-to-body=true ng-disabled=vm.inProgress><i class=\"fa fa-pencil fa-fw\"></i></button></span></div></div></div><hr class=hr-no-margin><div class=row><div class=col-xs-12><table class=\"table table-striped table-condensed table-bordered\"><thead><tr><th scope=col class=\"hidden-xs hidden-sm\">No</th><th scope=col class=\"hidden-xs hidden-sm\">SKU</th><th scope=col>Nama</th><th scope=col class=\"text-right hidden-xs hidden-sm\">Berat (kg)</th><th scope=col class=text-right>Harga</th><th scope=col class=text-right>Jml</th><th scope=col class=text-right>Total</th></tr></thead><tbody><tr ng-repeat=\"item in vm.produk_jual track by item.produk_id\"><td class=\"autofit text-right hidden-xs hidden-sm\">{{ $index + 1 }}</td><td class=\"autofit hidden-xs hidden-sm\">{{ item.sku }}</td><td><strong>{{ item.nama }}</strong><br><small>{{item.ket}}</small></td><td class=\"text-right hidden-xs hidden-sm\">{{ item.weight | number: 2 }}</td><td class=text-right><small class=text-old-price>{{ item.harga | number: 0 }}</small><br><strong>{{ item.harga_diskon | number: 0 }}</strong></td><td class=\"col-sm-1 text-right\">{{ item.jumlah }} pcs</td><td class=text-right><strong>{{ item.harga_diskon * (item.jumlah * 1) | number: 0 }}</strong></td></tr></tbody></table><hr class=hr-no-margin-top><table class=\"table table-striped table-condensed table-bordered\"><tbody><tr><td class=text-right><strong>Jumlah Awal</strong></td><td class=text-right>{{ vm.resume.totalQty | number: 0 }} pcs</td><td class=text-right>{{ vm.resume.totalPrice | number: 0 }}</td></tr><tr><td class=text-right><strong>Ongkos kirim via {{ vm.selectedCost.name | uppercase }} {{ vm.selectedCost.service.description }}</strong> <strong><sup class=text-danger>*</sup></strong></td><td class=text-right colspan=2>{{ vm.selectedCost.service.cost[0].value | number: 0 }}</td></tr><tr ng-if=\"vm.selectedCost.name === \'pos\'\"><td class=text-right><strong class=text-danger>Asuransi Ongkir via POS</strong></td><td class=text-right colspan=2>{{ 500 | number: 0 }}</td></tr><tr><td class=text-right><strong>Total Tagihan</strong></td><td class=text-right colspan=2><strong>{{ vm.resume.total | number: 0 }}</strong></td></tr><tr><td class=text-right><strong>Saldo Deposit</strong></td><td class=text-right colspan=2>{{ vm.balance | number: 0 }}</td></tr><tr ng-class=\"{\'danger\': (vm.lastBalance < 0)}\"><td class=text-right><strong ng-if=\"vm.lastBalance >= 0\">Sisa Saldo Deposit</strong> <strong ng-if=\"vm.lastBalance < 0\">Kekurangan Deposit</strong></td><td class=text-right colspan=2>{{ vm.lastBalance | number: 0 }}</td></tr></tbody></table></div></div><div class=row ng-if=\"vm.selectedCost.name === \'online\'\"><div class=\"col-xs-4 form-group\"><label style=\"color: #f01a0b\">Nomor Resi Online Booking</label><input type=text class=form-control placeholder=\"Masukkan nomor resi Online Booking\" uib-tooltip=\"Masukan nomor resi online booking.\" maxlength=30 ng-model=vm.jobNumber required></div><div class=\"col-xs-4 form-group\"><label style=\"color: #f01a0b\">Ekspedisi Marketplace</label><select class=form-control required ng-model=vm.ekspedisiMP><option value=SPX>Shopee Express</option><option value=IDX>ID Express</option><option value=jne>JNE</option><option value=j&t>J&T</option><option value=other>Ekspedisi lain</option></select></div><div class=\"col-xs-4 form-group\" ng-if=\"vm.ekspedisiMP === \'other\'\"><label style=\"color: #f01a0b\">Ekspedisi</label><input class=form-control name=ekspedisi_mp placeholder=\"Masukkan nama ekspedisi\" maxlength=30 required ng-model=vm.ekspedisiMPOther></div></div><div class=row><div class=\"col-xs-12 form-group\"><label>Catatan</label><textarea name=cust_note id=cust_note cols=30 rows=3 class=form-control placeholder=\"Catatan pesanan ...\" ng-model=vm.customerNote uib-tooltip=\"Masukkan catatan pesanan Anda\" maxlength=1500></textarea></div></div><div class=row><div class=col-xs-12><div class=\"alert alert-custom\"><p><strong><sup class=text-danger>*</sup></strong>Ongkos kirim adalah hasil pembulatan. Jika ada kelebihan, akan dikembalikan dalam bentuk <em>cash back</em>.</p></div></div></div></div><div class=row uib-collapse=\"vm.resume.totalFine === 0\"><div class=col-xs-12><div class=\"alert alert-custom\"><i class=\"fa fa-exclamation-circle\"></i>&nbsp;&nbsp; <strong>Perhatian:</strong> Anda akan dikenakan denda karena pengurangan produk sebesar Rp. {{ vm.resume.totalFine | number: 2 }}.</div></div></div></div><div class=modal-footer uib-collapse=\"vm.selectedContact.id === 0\"><div class=row><div class=\"col-xs-6 col-sm-4 form-group\"><button class=\"btn btn-default btn-block\" type=button ng-if=\"vm.currStep === 0 && !(vm.order.id > 0)\" ng-click=vm.clearAll() ng-disabled=vm.inProgress><i class=\"fa fa-times-circle\"></i> Hapus <span class=hidden-xs>Semua Produk</span></button> <button class=\"btn btn-default btn-block\" type=button ng-if=\"vm.currStep > 0\" ng-click=vm.prevStep() ng-disabled=vm.inProgress><i class=\"fa fa-arrow-circle-left\"></i> <span class=hidden-xs>Sebelumnya</span></button></div><div class=\"col-xs-6 col-sm-4 form-group\" ng-if=\"vm.currStep === 2\"><button class=\"btn btn-success btn-block\" type=button ng-click=vm.saveTransaction(true) ng-disabled=\"(vm.lastBalance < 0) || (vm.customSender.use && (!vm.customSender.nama || !vm.customSender.hp)) || (vm.inProgress)\" uib-tooltip=\"Pending transaksi. Tidak akan diproses\"><i class=\"fa fa-save\"></i> Pending</button></div><div class=\"col-xs-6 col-sm-4 pull-right form-group\" ng-if=\"vm.currStep < 2 \"><button class=\"btn btn-default btn-block\" type=button ng-click=vm.nextStep() ng-disabled=\"vm.waitNext || vm.inProgress\"><span class=hidden-xs>Selanjutnya</span>&nbsp; <i class=\"fa fa-arrow-circle-right\"></i></button></div><div class=\"col-xs-12 col-sm-4 form-group\" ng-if=\"vm.currStep === 2\"><button class=\"btn btn-warning btn-block\" type=button ng-click=vm.saveTransaction(false) ng-disabled=\"(vm.lastBalance < 0) || (vm.customSender.use && (!vm.customSender.nama || !vm.customSender.hp)) || (vm.inProgress) || (vm.selectedCost.name === \'online\' && (!vm.ekspedisiMP || (vm.ekspedisiMP === \'other\' && !vm.ekspedisiMPOther)))\" uib-tooltip=\"Bayar transaksi. Akan segera diproses\"><i class=\"fa fa-credit-card\"></i> Bayar</button></div></div></div></div>");
$templateCache.put("app/components/modals/TransactionDetail/TransactionDetailDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-shopping-cart\"></i> Detail Transaksi #{{::vm.id}}</h4></div><div class=modal-body><div class=row><div class=col-sm-6><table class=\"table table-condensed\"><tr><th scope=row class=col-sm-3>Waktu Pesan</th><td>: {{vm.transaksi.tgl | tsdate:\'dd MMMM yyyy - HH:mm:ss\'}}</td></tr><tr><th scope=row>Konsumen</th><td>: {{vm.transaksi.pembeli}}</td></tr><tr><th scope=row>Status</th><td>: <button class=\"btn btn-xs\" disabled ng-class=\"{\'btn-danger\': vm.transaksi.status ===\'pending\', \'btn-info\': vm.transaksi.status === \'dibayar\', \'btn-success\': \'selesai\'}\">{{vm.transaksi.status | uppercase}}</button></td></tr></table></div><div class=col-sm-6><table class=\"table table-condensed\"><tr><th scope=row class=col-sm-3>Ekspedisi</th><td ng-if=\"vm.transaksi.ekspedisi !== \'online\'\">: {{vm.transaksi.ekspedisi | uppercase}}</td><td ng-if=\"vm.transaksi.ekspedisi === \'online\'\">: {{vm.transaksi.lain_lain.ekspedisiMP !== \'other\' ? vm.transaksi.lain_lain.ekspedisiMP : vm.transaksi.lain_lain.ekspedisiMPOther }}</td></tr><tr><th scope=row>Nomor Resi</th><td>: {{ vm.transaksi.lain_lain.jobNumber ? vm.transaksi.lain_lain.jobNumber : vm.transaksi.no_resi}}</td></tr><!-- <tr>\n                  <th scope=\"row\" class=\"col-sm-3\">Waktu</th>\n                  <td>: {{vm.transaksi.updated_at | tsdate:\'dd MMMM yyyy - HH:mm:ss\'}}</td>\n                </tr> --></table></div></div><hr class=hr-no-margin><table class=\"table table-bordered table-striped table-condensed\"><thead><tr><th scope=col>No</th><th scope=col>SKU</th><th scope=col>Nama</th><th scope=col class=text-right>Qty</th><th scope=col class=text-right>Harga</th><!-- <th scope=\"col\" class=\"text-right\">Diskon (%)</th> --><!-- <th scope=\"col\" class=\"text-right\">Diskon (Nom)</th> --><th scope=col class=text-right>Total Harga</th></tr></thead><tbody><tr ng-repeat=\"item in vm.transaksi.produk_unik track by $index\"><td class=text-right>{{::$index + 1}}</td><td>{{::item.sku}}</td><td>{{::item.nama}} {{item.ukuran.option | uppercase}}</td><td class=text-right>{{::item.jumlah}}</td><td class=text-right>{{item.harga_jual - ((item.discount_persen/100) * item.harga_jual) | number:2}}</td><!-- <td class=\"text-right\">{{::item.discount_persen | number:2}}</td> --><!-- <td class=\"text-right\">{{::item.discount_nominal | number:2}}</td> --><td class=text-right>{{((item.harga_jual * item.jumlah) - ((item.discount_nominal * 1) + (item.jumlah * ((item.discount_persen/100) * item.harga_jual)))) | number:2}}</td></tr><tr><!-- <th colspan=\"3\" ></th> --><th scope=row colspan=5 class=text-right>Jumlah</th><td class=text-right><strong>{{((vm.transaksi.total_akhir * 1) + (vm.transaksi.discount_transaction_total * 1) - (vm.transaksi.total_lain_lain * 1)) | number:2}}</strong></td></tr><tr><!-- <th colspan=\"3\" ></th> --><th scope=row colspan=5 class=text-right>Ongkos kirim</th><td class=text-right><strong>{{(vm.transaksi.total_lain_lain * 1) | number:2}}</strong></td></tr><!-- <tr class=\"\">\n              <th scope=\"row\" colspan=\"2\" class=\"text-right\">Diskon (%): {{vm.transaksi.discount_persen | number:2}} %</th>\n              <th scope=\"row\" colspan=\"2\" class=\"text-right\">Diskon (Nom): {{vm.transaksi.discount_nominal | number:2}}</th>\n              <th></th>\n              <th scope=\"row\" colspan=\"2\" class=\"success text-right\">Total Diskon</th>\n              <td class=\"success text-right\"><strong>{{(vm.transaksi.discount_total * 1) | number:2}}</strong></td>\n            </tr> --><tr><!-- <th colspan=\"3\"></th> --><th scope=row colspan=5 class=text-right>Total Akhir</th><td class=text-right><strong>{{(vm.transaksi.total_akhir * 1) | number:2}}</strong></td></tr></tbody></table><div ng-if=\"vm.transaksi.pembayaran.data.length > 0\"><h4>Riwayat Pembayaran</h4><hr class=hr-no-margin><table class=\"table table-striped\"><thead><tr><!-- <th scope=\"col\" class=\"col-sm-1\">No</th> --><th scope=col class=col-sm-2>Tanggal</th><th scope=col class=col-sm-2>Metode</th><th scope=col class=\"col-sm-4 text-right\">Nominal</th><!-- <th scope=\"col\" class=\"col-sm-4\">Kasir</th> --></tr></thead><tbody><tr ng-repeat=\"termin in vm.transaksi.pembayaran.data\"><!-- <td class=\"text-right col-sm-1\">{{$index + 1}}</td> --><td class=col-sm-2>{{termin.tgl | tsdate: \'dd MMMM yyyy - HH:mm:ss\'}}</td><td class=col-sm-2><strong>{{termin.metode_bayar}}</strong></td><td class=\"text-right col-sm-4\">{{termin.nominal | number: 2}}</td><!-- <td class=\"col-sm-4\">{{termin.kasir}}</td> --></tr><!-- <tr>\n                <th colspan=\"3\"></th>\n                <th scope=\"row\" class=\"success text-right\">Total Pembayaran</th>\n                <th scope=\"row\" class=\"text-right col-sm-4 success\">{{vm.transaksi.bayar | number: 2}}</th>\n              </tr>\n              <tr>\n                <th colspan=\"3\"></th>\n                <th scope=\"row\" class=\"info text-right\">Uang Kembali</th>\n                <th scope=\"row\" class=\"text-right col-sm-4 info\">{{vm.transaksi.sisa_kembali | number: 2}}</th>\n              </tr> --></tbody></table></div><div ng-if=\"vm.transaksi.ekspedisi === \'online\'\"><h4>Resi Online</h4><hr class=hr-no-margin><div class=\"alert alert-info\"><p>Nomor Resi Online Booking: <strong>{{vm.transaksi.lain_lain.jobNumber}}</strong> ekspedisi <strong><span ng-if=\"vm.transaksi.lain_lain.ekspedisiMP !== \'other\'\">{{vm.transaksi.lain_lain.ekspedisiMP}}</span> <span ng-if=\"vm.transaksi.lain_lain.ekspedisiMP === \'other\'\">{{vm.transaksi.lain_lain.ekspedisiMPOther}}</span></strong></p></div></div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-check-circle\"></i> Selesai</button></div></div></div></div>");
$templateCache.put("app/components/modals/UserDialog/UserDialog.html","<div><form name=UserForm class=form-horizontal><div class=modal-header><h4 ng-if=!vm.isEdit><i class=\"fa fa-user\"></i> Tambahkan Pengguna Baru</h4><h4 ng-if=vm.isEdit><i class=\"fa fa-user\"></i> Edit Pengguna {{vm.user.username}}</h4></div><div class=modal-body><div ng-messages=UserForm.username.$error class=w_error><div ng-message=minlength>Panjang minimal 4 karakter</div><div ng-message=maxlength>Panjang maksimal 50 karakter</div></div><div class=form-group><label for=username class=\"col-sm-4 control-label text-left\">Email</label><div class=col-sm-8><input type=text class=form-control id=title placeholder=Email ng-model=vm.user.username minlength=4 maxlength=50 required name=username id=username></div></div><div ng-messages=UserForm.email.$error class=w_error><div ng-message=minlength>Panjang minimal 5 karakter</div><div ng-message=maxlength>Panjang maksimal 50 karakter</div><div ng-message=email>Masukkan email yang benar</div></div><div class=form-group><label for=Email class=\"col-sm-4 control-label text-left\">Email</label><div class=col-sm-8><input type=email class=form-control id=title placeholder=Email ng-model=vm.user.email minlength=5 maxlength=50 required name=email id=email></div></div><div class=form-group><label for=title class=\"col-sm-4 control-label text-left\">Nama</label><div class=col-sm-8><input type=text class=form-control id=title placeholder=Nama ng-model=vm.user.data.name maxlength=50 required></div></div><div class=form-group><label for=title class=\"col-sm-4 control-label text-left\">Tipe</label><div class=col-sm-8><select name=\"\" class=form-control ng-model=vm.user.type required ng-disabled=\"vm.user.id === 1\"><option value=ADMIN>Administrator</option><option value=CS>Customer Service</option></select></div></div><hr><div ng-messages=UserForm.password.$error class=w_error><div ng-message=minlength>Panjang minimal 6 karakter</div><div ng-message=maxlength>Panjang maksimal 50 karakter</div></div><div class=form-group><label for=title class=\"col-sm-4 control-label text-left\">Password</label><div class=col-sm-8><input type=password class=form-control id=password name=password placeholder=Password ng-model=vm.user.password minlength=6 maxlength=50 ng-required=!vm.isEdit uib-tooltip=\"Masukkan password atau biarkan kosong jika tidak ingin mengubah\"></div></div><div ng-messages=UserForm.confirm_password.$error class=w_error><!--<div ng-message=\"minlength\">Panjang minimal 6 karakter</div>--><!--<div ng-message=\"maxlength\">Panjang maksimal 50 karakter</div>--><div ng-message=pattern>Konfirmasi password tidak cocok</div></div><div class=form-group><label for=title class=\"col-sm-4 control-label text-left\">Konfirmasi Password</label><div class=col-sm-8><input type=password class=form-control id=confirm_password name=confirm_password placeholder=\"Konfirmasi Password\" ng-model=vm.user.confirm_password minlength=6 maxlength=50 ng-required=!vm.isEdit ng-pattern={{vm.user.password}}></div></div></div><div class=modal-footer><div class=row><div class=col-sm-6><button class=\"btn btn-success btn-block\" type=button ng-click=vm.cancel()><i class=\"fa fa-times-circle\"></i> Batal</button></div><div class=col-sm-6><button class=\"btn btn-danger btn-block\" type=button ng-disabled=UserForm.$invalid ng-click=vm.addUser()><i class=\"fa fa-save\"></i> <span ng-if=!vm.isEdit>Tambah Pengguna</span> <span ng-if=vm.isEdit>Edit Pengguna</span></button></div></div></div></form></div>");
$templateCache.put("app/components/modals/UserProfile/UserProfile.html","<div><div class=modal-header><h4><img src=assets/images/1.png alt=\"\" style=\"height: 24px; width: 24px\" class=\"img img-rounded\"> &nbsp;&nbsp; <span ng-if=!vm.user.auth.name>{{vm.user.auth.uname}}</span> <span ng-if=vm.user.auth.name>{{vm.user.auth.name}}</span></h4></div><div class=modal-body><form action=\"\" class=form name=userForm><div class=row><div class=\"col-xs-12 col-sm-2 form-group\"><select name=jenis_kelamin id=jenis_kelamin class=form-control ng-model=vm.user.contact.kelamin required><option value=P>Ibu</option><option value=L>Bpk</option></select></div><div class=\"col-xs-12 col-sm-10 form-group\"><div ng-messages=userForm.nama.$error class=w_error><div ng-message=required>Nama harus diisi</div><div ng-message=pattern>Panjang nama maksimal 100 huruf</div></div><input type=text name=nama id=nama class=form-control placeholder=\"Nama Lengkap\" ng-model=vm.user.auth.name required maxlength=100 id=name name=name></div></div><div class=row><div class=\"col-xs-12 col-sm-4 form-group\"><input type=email class=form-control placeholder=Email ng-model=vm.user.auth.email required readonly></div><div class=\"col-xs-12 col-sm-4 form-group\"><div ng-messages=userForm.hp.$error class=w_error><div ng-message=required>Nomor HP harus diisi</div><div ng-message=pattern>Nomor HP hanya boleh diisi angka</div></div><input type=text name=hp id=hp class=form-control placeholder=\"Nomor HP\" ng-model=vm.user.contact.hp required ng-pattern=vm.alamat.validasi.nomor></div><div class=\"col-xs-12 col-sm-4 form-group\"><div ng-messages=userForm.hp.$error class=w_error><div ng-message=pattern>Nomor Telepon hanya boleh diisi angka</div></div><input type=text class=form-control name=phone id=phone placeholder=\"Nomor Telepon lain\" ng-model=vm.user.contact.telp ng-pattern=vm.alamat.validasi.nomor></div></div><hr class=hr-no-margin-top><div class=\"row form-group\"><div class=\"col-xs-12 form-group\"><div ng-messages=userForm.alamat.$error class=w_error><div ng-message=required>Alamat harus diisi</div></div><input name=alamat id=alamat type=text class=form-control placeholder=Alamat ng-model=vm.user.contact.alamat required></div></div><div class=row><div class=\"col-xs-12 col-sm-10 form-group\"><ui-select ng-model=vm.alamat.kecamatan required><ui-select-match placeholder=Kecamatan><span>{{$select.selected.subdistrict_name}} {{$select.selected.type}} {{$select.selected.city}} - {{$select.selected.province}}</span></ui-select-match><ui-select-choices repeat=\"kec in (vm.alamat.source.kecamatan | filter: $select.search)\" refresh=vm.searchSubdistrict($select.search) refresh-delay=300 minimum-input-length=3><span><strong>{{kec.subdistrict_name}} {{kec.type}} {{kec.city}}</strong><br><small>{{kec.province}}</small></span></ui-select-choices></ui-select></div><div class=\"col-xs-12 col-sm-2 form-group\"><div ng-messages=userForm.kodepos.$error class=w_error><div ng-message=maxlength>Panjang kode pos maksimal 5 angka</div><div ng-message=pattern>Kode Pos hanya boleh diisi angka</div></div><input type=text name=kodepos id=kodepos class=form-control placeholder=\"Kode Pos\" ng-model=vm.user.contact.kode_pos maxlength=5 ng-pattern=vm.alamat.validasi.nomor></div></div><hr class=hr-no-margin-top><div class=row><div class=\"col-xs-12 form-group\"><textarea class=form-control placeholder=Keterangan... rows=3 ng-model=vm.user.contact.extra.keterangan></textarea></div></div><hr><div class=row><div class=\"col-xs-12 col-sm-6 form-group\"><div ng-messages=userForm.password.$error class=w_error><div ng-message=minlength>Panjang minimal 6 karakter</div><div ng-message=maxlength>Panjang maksimal 50 karakter</div></div><input type=password class=form-control placeholder=\"Ganti password\" ng-model=vm.user.auth.password uib-tooltip=\"Biarkan kosong jika tidak ingin mengganti password\" minlength=6 maxlength=50 name=password id=password></div><div class=\"col-xs-12 col-sm-6 form-group\" ng-if=vm.user.auth.password><div ng-messages=userForm.confirm_password.$error class=w_error><div ng-message=pattern>Konfirmasi password tidak cocok</div></div><input type=password class=form-control placeholder=\"Masukkan ulang password\" ng-model=vm.user.auth.confirm_password ng-required=vm.user.auth.password minlength=6 maxlength=50 id=confirm_password name=confirm_password ng-pattern=vm.user.auth.password></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-xs-6 col-sm-4 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish() ng-disabled=\"userForm.$invalid || vm.invalidPassword()\"><i class=\"fa fa-save\"></i> Simpan</button></div><div class=\"col-xs-6 col-sm-4\"><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal() ng-if=vm.user.auth.contact_id><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/ViewDepositTicket/ViewDepositTicket.html","<div><div class=modal-header><h4>Topup Deposit #{{ vm.depositData.id }} <button class=\"btn btn-danger btn-xs pull-right\" ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i></button></h4></div><div class=modal-body><div class=container-fluid ng-if=vm.depositData><div class=row><div class=col-12><p ng-if=\"vm.depositData.status === \'NEW\'\">Silahkan transfer deposit anda sebelum <strong class=text-danger>{{ vm.depositData.expired | tsdate: \'dd MMMM yyyy - HH:mm:ss\' }} WIB.</strong></p><div class=\"alert alert-danger\" ng-if=\"vm.depositData.status === \'CANCELED\'\"><p>Tiket ini telah dibatalkan oleh sistem karena belum transfer sampai batas waktu yg ditentukan (<strong>{{ vm.depositData.expired | tsdate: \'dd MMMM yyyy - HH:mm:ss\' }} WIB.</strong>)</p></div><div class=\"alert alert-success\" ng-if=\"vm.depositData.status === \'FINISHED\'\"><p>Tiket ini telah diproses dan deposit Anda telah ditambahkan</p></div><p ng-if=\"vm.depositData.status === \'TRANSFER\'\">Sistem akan otomatis memeriksa transfer deposit Anda.</p><table class=table><tbody><tr><th scope=row class=col-sm-3>Rekening</th><td><strong>{{vm.depositData.bank}} {{vm.depositData.account_number}}</strong><br>a.n {{vm.depositData.account_name}}</td></tr><tr><th scope=row class=col-sm-3>Total Transfer</th><td>Rp. <strong>{{vm.depositData.total_transfer | number}}</strong></td></tr><tr ng-if=\"vm.depositData.status === \'NEW\'\"><th scope=row class=col-sm-3></th><td>Pastikan transfer <strong>sama persis sampai 3 angka terakhir</strong>.</td></tr></tbody></table><p ng-if=\"(vm.retry < 1) && vm.depositData.status === \'NEW\'\"><strong>Hanya jika sudah transfer</strong>, centang <em>\"Saya sudah transfer\"</em> dan klik <em>\"Konfirmasi\"</em>.</p><div class=\"alert alert-success\" ng-if=\"vm.retry > 0\"><div class=row><div class=\"col-sm-2 text-center\"><i class=\"fa fa-check-circle fa-4x\"></i></div><div class=col-sm-10><p>Konfirmasi Telah diterima. <strong style=\"text-decoration: underline\">Saldo akan masuk dalam waktu 2 menit</strong></p><p>Jika dalam 3 menit saldo belum masuk, <strong>hubungi CS dengan mengirim bukti trasnfer</strong></p></div></div></div></div></div></div></div><div class=modal-footer ng-if=\"(vm.retry < 1) && (vm.depositData && vm.depositData.status === \'NEW\')\"><div class=row><div class=\"col-xs-6 col-sm-8\"><div class=\"checkbox text-left\"><label><input type=checkbox ng-model=vm.checkConfirm> Saya sudah transfer</label></div></div><div class=\"col-xs-6 col-sm-4 pull-right\"><button class=\"btn btn-info btn-block\" type=button ng-click=vm.confirmTransfer() ng-disabled=\"vm.disabled || !vm.checkConfirm || vm.retry > 0\"><i class=\"fa fa-save\"></i> Konfirmasi</button></div></div></div></div>");}]);